<!-- 组队瓜分奖品 -->
<template>
  <div class="createPlayStep new-input-box" v-loading="loading">
    <!-- 头部返回 -->
    <div class="backBox">
      <jd-back
        @back="returnBack()"
        :title="['互动广场']"
        :subTitle="activityData.name"
        style="padding-bottom: 0"
      ></jd-back>
    </div>
    <div class="formBox">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStepNum">
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>

      <!-- 活动条件表单设置 -->
      <div class="secondstep" v-if="localStepNum == 0 || localStepNum == 1">
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          class="backgroundForm"
          label-width="150px"
        >
          <el-form-item label="参与方式:" required>
            <div style="padding: 10px 0">
              <el-radio-group
                v-model="ruleForm.joinType"
                :disabled="activityData.isStart"
                @change="changeParticipateType"
              >
                <el-radio style="margin-bottom: 18px" :label="0"
                  >用户报名参与(消费者需要手动报名，未报名不统计)</el-radio
                >
                <el-form-item v-if="ruleForm.joinType == 0">
                  <div style="border: 1px solid #f0f0f0; padding: 20px">
                    <div class="flex-column">
                      <el-checkbox
                        v-model="isSignLimitTime"
                        @change="
                          () => {
                            ruleForm.joinStartTime = '';
                            ruleForm.joinEndTime = '';
                          }
                        "
                        :disabled="activityData.isStart"
                        >限制报名时间（不勾选则表示活动周期内都可报名）</el-checkbox
                      >
                      <div v-if="isSignLimitTime" class="greyBg-box">
                        <span class="mr8">用户在</span>
                        <div class="my_select_time">
                          <el-date-picker
                            prefix-icon="no_icon"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            v-model="ruleForm.joinStartTime"
                            placeholder="请输入报名时间"
                            class="picker"
                            size="small"
                            :disabled="activityData.isStart"
                            :clearable="false"
                            :picker-options="pickerOptionApplyStart"
                            @blur="(val) => applyBlur(val, 'start')"
                            @change="applyTimeChange"
                          ></el-date-picker>
                          <span class="time_to_text">至</span>
                          <el-date-picker
                            prefix-icon="no_icon"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            v-model="ruleForm.joinEndTime"
                            placeholder="请输入报名时间"
                            class="picker"
                            size="small"
                            :clearable="false"
                            :picker-options="pickerOptionApplyEnd"
                            default-time="['23:59:59']"
                            @change="applyTimeChange"
                            @blur="(val) => applyBlur(val, 'end')"
                          ></el-date-picker>
                          <i
                            class="el-icon-circle-close date_icon1"
                            v-if="!disabled"
                            @click="clearApplyTime"
                          ></i>
                          <img
                            src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                            alt=""
                            class="date_icon2"
                          />
                        </div>
                        <span style="margin: 0 8px">期间内报名</span>
                        <span v-if="activityData.isStart" style="color: #f56c6c"
                          >活动进行中仅支持修改结束时间</span
                        >
                      </div>
                    </div>
                  </div>
                </el-form-item>
                <el-radio :label="1"
                  >免报名参与(消费者无需报名活动，活动期间内进入活动时自动判断消费者是否符合条件，符合则自动报名，免保名活动不支持配置参与条件)</el-radio
                >
              </el-radio-group>
            </div>
          </el-form-item>
          <informationForm
            @selectPeopleSure="selectPeopleSure"
            @getMemberFn="getMemberFn"
            :defaultActMember.sync="actMember"
            :defaultActivityStartTime="activityStartTime"
            :defaultActivityEndTime="activityEndTime"
            :plusObject.sync="ruleDTO.plusObject"
            :openCardStartTime.sync="ruleDTO.openCardStartTime"
            :openCardEndTime.sync="ruleDTO.openCardEndTime"
            :peopleSelected.sync="peopleSelected"
            ref="informationForm"
            v-model="ruleForm"
            :isEdit="false"
            :disabled="activityData.isStart"
            :localStepNum="localStepNum"
            :needNonMember="true"
            :activityId="68"
            :showOpenCardTip="true"
            :objExtraTip="objExtraTip"
            :customerPaperwork="customerPaperwork"
            @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
          >
          </informationForm>
          <div>
            <jd-title label="场景配置" type="bold"></jd-title>
            <div class="mt20">
              <el-form-item label="活动场景：" required>
                <el-radio-group
                  v-model="ruleDTO.activityScene"
                  :disabled="activityData.isStart"
                  @change="changeScene"
                >
                  <el-radio :label="1" :disabled="actMember == 2"
                    >会员生命周期</el-radio
                  >
                  <el-radio :label="2">试用回购正装</el-radio>
                </el-radio-group>
                <el-tooltip placement="top">
                  <template #content>
                    <div>场景说明：</div>
                    <div>
                      1、会员首购：用户入会后领取新会员专属价进行首购，再根据各阶段复购条件进行下单，每次完成订单可领取奖品
                    </div>
                    <div>
                      2、试用回购正装：用户根据活动购买指定试用装，再根据各阶段进行首购到复购店铺正装品，每次完成订单可领取奖品
                    </div>
                  </template>
                  <el-button type="text" style="width: 35px">
                    <i class="el-icon-question"></i>
                  </el-button>
                </el-tooltip>
              </el-form-item>

              <el-form-item label="阶段名称：" required>
                <el-input
                  class="w380"
                  placeholder="请输入阶段名称"
                  v-model="firstStageConfig.stageName"
                  maxlength="10"
                  show-word-limit
                ></el-input>
              </el-form-item>
              <template v-if="ruleDTO.activityScene == 1">
                <el-form-item label="会员首购场景：" required>
                  <el-checkbox
                    :disabled="activityData.isStart || backgroundOpacity"
                    v-model="firstStageConfig.enableExclusivePrice"
                    @change="changeExclusivePrice"
                    >会员专属价下单</el-checkbox
                  >
                  <el-checkbox
                    :disabled="activityData.isStart || backgroundOpacity"
                    v-model="firstStageConfig.enableFirstPurchase"
                    @change="changeFirstPurchase"
                    >会员首购下单</el-checkbox
                  >
                  <span class="ml8 tips_red"
                    >注：为保证用户体验，至少勾选一个场景</span
                  >
                </el-form-item>
                <el-form-item
                  label="会员专属价："
                  v-if="firstStageConfig.enableExclusivePrice"
                  required
                >
                  <div class="flexc-cen-x">
                    <span class="mr8">用户在入会后</span>
                    <el-input
                      class="w90"
                      :disabled="activityData.isStart || backgroundOpacity"
                      placeholder="请输入"
                      v-model="firstStageConfig.exclusivePriceConfig.joinDays"
                      @input="
                        firstStageConfig.exclusivePriceConfig.joinDays =
                          getNumberData(1, $event, 0, 1, 999999)
                      "
                    ></el-input>
                    <span class="ml8"
                      >天内加购促销活动商品自动派发促销价活动价,并下单订单条件达成已完成状态。</span
                    >
                  </div>
                  <div class="setting-box mt12">
                    <el-form-item label="选择促销活动：" required>
                      <jd-table :tableData="promotionList">
                        <el-table-column
                          :label="venderType ? '令牌名称' : '专享价名称'"
                          min-width="140px"
                          prop="title"
                        ></el-table-column>
                        <el-table-column
                          v-if="!venderType"
                          label="值"
                          prop="price"
                          min-width="140px"
                        ></el-table-column>
                        <el-table-column label="奖品图" min-width="140px">
                          <template slot-scope="scope">
                            <img
                              v-if="scope.row.logo"
                              class="logo-style"
                              :src="scope.row.logo"
                              alt=""
                            />
                          </template>
                        </el-table-column>
                        <el-table-column label="奖品数量" min-width="140px">
                          <template slot-scope="scope">
                            <el-input
                              v-model.number="scope.row.totalAmount"
                              @input.native="
                                (e) =>
                                  (scope.row.totalAmount = checkputn(
                                    e,
                                    scope.row
                                  ))
                              "
                              placeholder="不限制"
                              @input="
                                (scope.row.totalAmount = getNumberData(
                                  1,
                                  $event,
                                  0,
                                  1,
                                  999999
                                )),
                                  prizeNum(scope.row)
                              "
                              @blur="beAdd(scope.row)"
                              :disabled="
                                (activityData.isStart && !scope.row.minNum) ||
                                activityData.isStart ||
                                backgroundOpacity
                              "
                            ></el-input>
                          </template>
                        </el-table-column>
                        <el-table-column label="操作" min-width="140px">
                          <template slot-scope="scope">
                            <jd-button
                              :disabled="backgroundOpacity"
                              type="blueText"
                              @click="selectPromotion(scope.row)"
                            >
                              选择{{ venderType ? "令牌" : "专享价" }}
                            </jd-button>
                            <jd-button
                              type="blueText"
                              :disabled="
                                activityData.isStart || backgroundOpacity
                              "
                              @click="removePromotion"
                            >
                              清空
                            </jd-button>
                          </template>
                        </el-table-column>
                      </jd-table>
                    </el-form-item>
                    <el-form-item
                      label="指定商品："
                      v-if="designatedSku.length"
                    >
                      <jd-table
                        :tableData="designatedSku"
                        v-if="designatedSku.length"
                      >
                        <el-table-column label="商品图" min-width="140px">
                          <template slot-scope="scope">
                            <img
                              v-if="scope.row.logo"
                              class="logo-style"
                              :src="scope.row.logo"
                              alt=""
                            />
                          </template>
                        </el-table-column>
                        <el-table-column
                          label="商品名称（12字内）"
                          min-width="140px"
                        >
                          <template slot-scope="scope">
                            <el-input
                              v-model="scope.row.skuName"
                              maxlength="12"
                              :disabled="backgroundOpacity"
                              show-word-limit
                              style="width: 230px"
                              placeholder="请输入"
                            ></el-input>
                          </template>
                        </el-table-column>

                        <el-table-column
                          label="京东价"
                          prop="jdPrice"
                          min-width="140px"
                        >
                        </el-table-column>

                        <el-table-column label="会员专属价" min-width="140px">
                          <template slot-scope="scope">
                            <el-input
                              v-model="scope.row.exclusivePrice"
                              placeholder="请输入"
                              @input="
                                (scope.row.exclusivePrice = getNumberData(
                                  1,
                                  $event,
                                  1,
                                  1,
                                  999999
                                )),
                                  prizeNum(scope.row)
                              "
                              :disabled="
                                activityData.isStart || backgroundOpacity
                              "
                            ></el-input>
                          </template>
                        </el-table-column>

                        <el-table-column label="操作" min-width="140px">
                          <template slot-scope="scope">
                            <el-upload
                              action="/jd-hd-web/image/upload"
                              :show-file-list="false"
                              :on-success="uploadLogo"
                              :before-upload="(file) => beforeUploadPrize(file)"
                              list-type="picture"
                              ref="uploadRef"
                              :disabled="
                                activityData.isStart || backgroundOpacity
                              "
                            >
                              <jd-button
                                :disabled="
                                  activityData.isStart || backgroundOpacity
                                "
                                type="blueText"
                              >
                                上传商品图片
                              </jd-button>
                            </el-upload>
                          </template>
                        </el-table-column>
                      </jd-table>
                    </el-form-item>
                  </div>
                </el-form-item>
                <el-form-item
                  label="会员首购："
                  required
                  v-if="firstStageConfig.enableFirstPurchase"
                >
                  <div>用户所下订单需满足以下条件</div>
                  <div class="setting-box mt12">
                    <el-form-item label="下单店铺:" required>
                      <orderShopCom
                        :venderIds.sync="
                          purchaseOrderConfig.orderRuleConfig.venderIds
                        "
                        :multiShopGoods.sync="orderMultiShopGoods"
                        :sellerSkuList.sync="
                          purchaseOrderConfig.orderRuleConfig.sellerSkuList
                        "
                        :isDisabled="activityData.isStart"
                        @changeShop="changeShop"
                      />
                    </el-form-item>
                    <el-form-item label="下单时间：" required>
                      <el-select
                        :disabled="activityData.isStart || backgroundOpacity"
                        v-model="purchaseOrderConfig.orderTimeConfig.timeType"
                        @change="changeTimeType"
                      >
                        <el-option label="用户入会后" :value="1"></el-option>
                        <el-option
                          label="用户在指定时间"
                          :value="2"
                        ></el-option>
                      </el-select>
                      <el-input
                        v-model="purchaseOrderConfig.orderTimeConfig.joinDays"
                        placeholder="请输入"
                        @input="
                          purchaseOrderConfig.orderTimeConfig.joinDays =
                            getNumberData(1, $event, 0, 1, 999999)
                        "
                        class="w90 ml8"
                        :disabled="activityData.isStart || backgroundOpacity"
                        v-if="purchaseOrderConfig.orderTimeConfig.timeType == 1"
                      ></el-input>

                      <div class="my_select_time ml8" v-else>
                        <el-date-picker
                          prefix-icon="no_icon"
                          v-model="
                            purchaseOrderConfig.orderTimeConfig.startTime
                          "
                          type="datetime"
                          placeholder="开始日期"
                          size="small"
                          format="yyyy-MM-dd HH:mm:ss"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          default-time="00:00:00"
                          style="width: 185px; font-size: 12px"
                          class="time1"
                          :picker-options="orderPickerOptionsStart"
                          :default-time="
                            this.ruleForm.startTime.substring(
                              11,
                              this.$getDate(30)[0].length
                            )
                          "
                          :clearable="false"
                          :disabled="activityData.isStart || backgroundOpacity"
                        >
                        </el-date-picker>
                        <div class="time_to_text">至</div>
                        <el-date-picker
                          prefix-icon="no_icon"
                          v-model="purchaseOrderConfig.orderTimeConfig.endTime"
                          type="datetime"
                          placeholder="结束日期"
                          size="small"
                          format="yyyy-MM-dd HH:mm:ss"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          default-time="23:59:59"
                          :default-time="
                            this.ruleForm.endTime.substring(
                              11,
                              this.$getDate(30)[0].length
                            )
                          "
                          style="width: 200px; font-size: 12px"
                          class="time2"
                          :picker-options="orderPickerOptionsEnd"
                          :clearable="false"
                          :disabled="activityData.isStart || backgroundOpacity"
                        >
                        </el-date-picker>
                        <i
                          class="el-icon-circle-close date_icon1"
                          v-if="!disabled"
                          @click="clearTime()"
                        ></i>
                        <img
                          src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                          alt=""
                          class="date_icon2"
                        />
                      </div>
                      <span
                        class="ml8"
                        v-if="purchaseOrderConfig.orderTimeConfig.timeType == 1"
                        >天</span
                      >
                      内下单
                      <div v-if="purchaseOrderConfig.orderTimeConfig.timeType == 2 && purchaseOrderConfig.orderTimeConfig.orderGetCondition === 0" style="color:red">注：用户需在下单时间范围内加入会员，且下单时间需在入会后到下单结束时间，（即先入会后下单）才满足活动奖品领取要求</div>
                      <div v-if="purchaseOrderConfig.orderTimeConfig.timeType == 2 && purchaseOrderConfig.orderTimeConfig.orderGetCondition === 1" style="color:red">注：入会时间和下单时间均在指定时间范围内即可满足活动奖品领取要求</div>
                    </el-form-item>
                    <!-- 订单获取条件：仅首购阶段且timeType=2时显示 -->
                    <el-form-item 
                      label="订单获取条件：" 
                      v-if="firstStageConfig.enableFirstPurchase && purchaseOrderConfig.orderTimeConfig.timeType == 2">
                      <el-radio-group 
                        v-model="purchaseOrderConfig.orderTimeConfig.orderGetCondition" 
                        :disabled="activityData.isStart || backgroundOpacity">
                        <el-radio :label="0">下单时间需在入会时间后</el-radio>
                        <el-radio :label="1">入会和下单均在指定下单时间内即可满足</el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item label="计量单位：" required>
                      <el-radio-group
                        @change="changePurchaseOrderStatisticType"
                        v-model="
                          purchaseOrderConfig.orderRuleConfig.statisticType
                        "
                        :disabled="activityData.isStart || backgroundOpacity"
                      >
                        <el-radio :label="0">按下单金额</el-radio>
                        <el-radio
                          :label="item.id"
                          :disabled="
                            purchaseOrderConfig.orderRuleConfig.venderIds
                              .length > 1
                          "
                          v-for="(item, index) in unitList"
                          :key="index"
                          >按{{ item.name || "" }}统计</el-radio
                        >
                      </el-radio-group>
                      <jd-tip class="mt5">
                        支持自定义“箱、罐、瓶....”等计量单位，<span
                          class="goToMeasureUnitText"
                          @click="goToMeasureUnit"
                          >去设置计量单位></span
                        >
                      </jd-tip>
                    </el-form-item>
                    <el-form-item label="金额统计类型：" required>
                      <el-radio-group
                        v-model="
                          purchaseOrderConfig.orderRuleConfig.orderPaymentType
                        "
                        :disabled="activityData.isStart || backgroundOpacity"
                      >
                        <el-radio :label="1">
                          <span>订单金额（后台价）</span>
                          <el-tooltip class="item" effect="dark" content="是指京东后台价，不等于商城前台页面展示的价格，前台页面无法查看该后台价格；如需查询后台价格，请联系采销核实。" placement="top-start">
                            <div class="new-icon-box" style="margin: -3px 8px"></div>
                          </el-tooltip>
                        </el-radio>
                        <el-radio :label="0" v-if="!isVenderType">
                          <span>用户应付金额</span>
                          <el-tooltip class="item" effect="dark" content="订单商品原价总额-订单优惠总额+订单运费+税费+调整运费金额=用户应付金额" placement="top-start">
                            <div class="new-icon-box" style="margin: -3px 8px"></div>
                          </el-tooltip>
                        </el-radio>
                        <el-radio :label="2" v-if="!isVenderType">
                          <span>用户实付金额</span>
                          <el-tooltip class="item" effect="dark" content="用户应付金额-支付优惠总额=用户实付金额" placement="top-start">
                            <div class="new-icon-box" style="margin: -3px 8px"></div>
                          </el-tooltip>
                        </el-radio>
                      </el-radio-group>
                      <div class="tips_red">
                        注意：由于接口原因，自营仅支持统计订单金额，pop可按需选择统计实付金额或订单金额。
                      </div>
                    </el-form-item>
                    <el-form-item label="商品要求：" required>
                      <span
                        v-if="
                          purchaseOrderConfig.orderRuleConfig.statisticType != 0
                        "
                      >
                        指定计量单位商品
                      </span>
                      <!-- <el-radio-group
                        v-else
                        v-model="purchaseOrderConfig.orderRuleConfig.filterType"
                        :disabled="activityData.isStart || backgroundOpacity || purchaseOrderConfig.orderRuleConfig.statisticType != 0"
                      >
                        <el-radio :label="0">全部商品</el-radio>
                        <el-radio :label="1">指定商品</el-radio>
                        <el-radio :label="2">排除商品</el-radio>
                      </el-radio-group> -->
                      <productReqCom
                        v-else
                        :filterType.sync="
                          purchaseOrderConfig.orderRuleConfig.filterType
                        "
                        :venderIds.sync="
                          purchaseOrderConfig.orderRuleConfig.venderIds
                        "
                        :sellerSkuList.sync="
                          purchaseOrderConfig.orderRuleConfig.sellerSkuList
                        "
                        :multiShopGoods.sync="orderMultiShopGoods"
                        :isCreated="isCreated"
                        :isDisabled="activityData.isStart"
                        addGoodText="已选商品"
                        @changeFilterType="filterTypeChange"
                      />
                      <!-- <jd-button
                        class="ml8"
                        v-if="purchaseOrderConfig.orderRuleConfig.statisticType == 0"
                        @click="openGoods"
                        :disabled="
                          purchaseOrderConfig.orderRuleConfig.filterType == 0
                        "
                        >已选商品{{ specifyOrExcludeGoods.length }}个</jd-button
                      > -->
                      <jd-button
                        class="ml8"
                        v-if="
                          purchaseOrderConfig.orderRuleConfig.statisticType != 0
                        "
                        @click="isShowSelectUnitGoods = true"
                        :disabled="
                          purchaseOrderConfig.orderRuleConfig.filterType == 0
                        "
                        >已选商品{{ specifyOrExcludeGoods.length }}个</jd-button
                      >
                    </el-form-item>
                    <el-form-item label="指定商品规则:" v-if="purchaseOrderConfig.orderRuleConfig.orderPaymentType==1&&purchaseOrderConfig.orderRuleConfig.filterType == 1">
                      <el-select style="width: 280px;" v-model="purchaseOrderConfig.orderRuleConfig.filterSkuType" :disabled="activityData.isStart" placeholder="">
                        <el-option label="只要订单包含指定商品就整单计算" :value="0"></el-option>
                        <el-option label="仅统计订单内指定商品的金额和件数" :value="1"></el-option>
                      </el-select>
                      <jd-button type="blueText" class="ml12" @click="viewStatisticsLogic">查看统计逻辑</jd-button>
                    </el-form-item>
                    <el-form-item label="订单状态：" required>
                      <el-radio-group
                        v-model="orderStatus"
                        :disabled="activityData.isStart || backgroundOpacity"
                      >
                        <el-radio :label="0">已完成</el-radio>
                      </el-radio-group>
                      <el-tooltip placement="top">
                        <template #content>
                          <div>订单状态说明：</div>
                          <div>
                            1、已完成：订单确认收货,确认收货后取消订单为售后行为，无法获取取消订单状态
                          </div>
                        </template>
                        <el-button class="ml8" type="text"
                          ><i class="el-icon-question"></i
                        ></el-button>
                      </el-tooltip>
                    </el-form-item>
                    <el-form-item label="订单拆单后是否合并:" label-width="160px" required>
                      <el-radio-group
                        :disabled="activityData.isStart"
                        v-model="purchaseOrderConfig.orderRuleConfig.mergeOrder"
                      >
                        <el-radio :label="false">否</el-radio>
                        <el-radio :label="true">是</el-radio>
                      </el-radio-group>
                      <jd-button type="blueText" class="ml12" @click="viewMergeLogic">查看合并拆单逻辑</jd-button>
                    </el-form-item>
                    <el-form-item label="奖品配置：" required>
                      <el-radio-group
                        v-model="purchaseOrderConfig.prizeConfig.enabled"
                        :disabled="activityData.isStart || backgroundOpacity"
                        @change="handlePrizeConfigChange"
                      >
                        <el-radio :label="false">不设置奖品</el-radio>
                        <el-radio :label="true">设置奖品</el-radio>
                      </el-radio-group>
                      <div
                        class="prize-box mt12"
                        v-if="purchaseOrderConfig.prizeConfig.enabled"
                      >
                        <el-form-item
                          label="奖品发放形式："
                          label-width="110px"
                        >
                          <el-radio-group
                            v-model="purchaseOrderConfig.prizeConfig.sendType"
                            :disabled="
                              activityData.isStart || backgroundOpacity
                            "
                            @change="handleSendTypeChange"
                          >
                            <el-radio :label="0">立即发放</el-radio>
                            <el-radio :label="1">
                              <span class="mr8">确认收货</span
                              ><el-input
                                class="w90"
                                v-model="
                                  purchaseOrderConfig.prizeConfig.delayDays
                                "
                                @input="
                                  purchaseOrderConfig.prizeConfig.delayDays =
                                    getNumberData(1, $event, 0, 1, 999999)
                                "
                                :disabled="
                                  purchaseOrderConfig.prizeConfig.sendType !=
                                    1 ||
                                  activityData.isStart ||
                                  backgroundOpacity
                                "
                              ></el-input>
                              <span class="ml8">天后发放</span>
                            </el-radio>
                            <el-radio :label="2">
                              <span class="mr8">活动结束</span
                              ><el-input
                                class="w90"
                                v-model="
                                  purchaseOrderConfig.prizeConfig.delayDays2
                                "
                                @input="
                                  purchaseOrderConfig.prizeConfig.delayDays2 =
                                    getNumberData(1, $event, 0, 1, 999999)
                                "
                                :disabled="
                                  purchaseOrderConfig.prizeConfig.sendType !=
                                    2 ||
                                  activityData.isStart ||
                                  backgroundOpacity
                                "
                              ></el-input>
                              <span class="ml8">天后发放</span>
                            </el-radio>
                          </el-radio-group>

                          <el-tooltip placement="top">
                            <template #content>
                              <div>
                                1.立即发放:用户下单符合条件后。系统立即发放奖品
                              </div>
                              <div>
                                2.确认收货后发放:用户确认收货满xx天后,商家需自行发货
                              </div>
                              <div>
                                3.活动结束后发放:活动结束x天后，商家需自行发货
                              </div>
                            </template>
                            <el-button class="ml8" type="text">
                              <span>发放规则</span>
                              <i class="el-icon-question"></i
                            ></el-button>
                          </el-tooltip>
                        </el-form-item>
                        <el-form-item
                          label="奖品设置："
                          required
                          label-width="110px"
                        >
                          <jd-button
                            type="blue"
                            @click="addPrizeSetting"
                            :disabled="
                              prizeList.length == 5 ||
                              activityData.isStart ||
                              backgroundOpacity
                            "
                          >
                            +添加奖品设置（{{ prizeList.length }}/5）</jd-button
                          >
                          <span class="ml8">
                            注：开启配置奖品后，最少配置一个奖品，配置多个奖品时C端用户仅可领取其中一个奖品
                          </span>
                          <div
                            class="prize-set mt12"
                            v-for="(item, index) in prizeList"
                            :key="index"
                          >
                            <i
                              v-if="prizeList.length > 1"
                              class="el-icon-delete delete-icon"
                              @click="deleteStepPrize(index)"
                            ></i>
                            <div>奖品{{ index + 1 }}</div>
                            <div class="ml20">
                              <div class="mb12">
                                <span class="mr8"
                                  >消费门槛：{{
                                    purchaseOrderConfig.orderRuleConfig
                                      .statisticType == 0
                                      ? "金额"
                                      : purchaseOrderUnitName + "数"
                                  }}≥</span
                                >
                                <el-input
                                  v-model="item.orderAmtLimit"
                                  placeholder="请输入"
                                  class="w90"
                                  @input="
                                    item.orderAmtLimit = getNumberData(
                                      1,
                                      $event,
                                      1,
                                      0,
                                      999999
                                    )
                                  "
                                  :disabled="
                                    activityData.isStart || backgroundOpacity
                                  "
                                ></el-input>
                                <span class="ml8">
                                  {{
                                    purchaseOrderConfig.orderRuleConfig
                                      .statisticType == 0
                                      ? "元"
                                      : purchaseOrderUnitName
                                  }}
                                </span>
                                <!-- <span class="ml12 tips_red"
                                  >注：订单包含指定商品加上店铺内其他商品的金额</span
                                > -->
                              </div>
                              <jd-table :tableData="item.goodsList">
                                <el-table-column
                                  label="奖品类型"
                                  min-width="90px"
                                >
                                  <template slot-scope="scope">
                                    {{ getPrizeTypeName(scope.row.prizeType) }}
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  label="奖品价值"
                                  prop="price"
                                  min-width="90px"
                                ></el-table-column>
                                <el-table-column label="图片" width="100">
                                  <template slot-scope="scope">
                                    <img
                                      v-if="scope.row.logo"
                                      :src="scope.row.logo"
                                      class="prize-logo"
                                    />
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  label="奖品名称（12字内）"
                                  min-width="200px"
                                >
                                  <template slot-scope="scope">
                                    <el-input
                                      v-model="scope.row.title"
                                      maxlength="12"
                                      show-word-limit
                                      style="width: 200px"
                                      placeholder="请输入"
                                    ></el-input>
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  label="奖品数量"
                                  min-width="90px"
                                >
                                  <template slot-scope="scope">
                                    <el-input
                                      v-model.number="scope.row.totalAmount"
                                      @input.native="
                                        (e) =>
                                          (scope.row.totalAmount = checkputn(
                                            e,
                                            scope.row
                                          ))
                                      "
                                      placeholder="请输入"
                                      @input="
                                        (scope.row.totalAmount = getNumberData(
                                          1,
                                          $event,
                                          0,
                                          1,
                                          999999
                                        )),
                                          prizeNum(scope.row)
                                      "
                                      @blur="beAdd(scope.row)"
                                      :disabled="
                                        (activityData.isStart &&
                                          !scope.row.minNum) ||
                                        activityData.isStart ||
                                        backgroundOpacity|| (scope.row.prizeType == 2 &&scope.row.cycleType==1&&scope.row.totalAmount)
                                      "
                                    ></el-input>
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  label="剩余库存"
                                  min-width="90px"
                                  v-if="activityData.isStart"
                                >
                                  <template slot-scope="scope">
                                    <el-input
                                      v-model.number="scope.row.remanentAmount"
                                      style="width: 80px"
                                      disabled
                                    ></el-input>
                                    份
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  label="每日发放限额"
                                  width="120"
                                >
                                  <template slot-scope="scope">
                                    <dailyLimitConfig
                                      :row="scope.row"
                                      :backgroundOpacity="backgroundOpacity"
                                      :limitBtnDisabled="backgroundOpacity"
                                    ></dailyLimitConfig>
                                  </template>
                                </el-table-column>
                                <el-table-column label="操作" min-width="120px">
                                  <template slot-scope="scope">
                                    <jd-button
                                      type="blueText"
                                      @click="
                                        selectGoodFn(
                                          item.goodsList,
                                          index,
                                          scope
                                        )
                                      "
                                      :disabled="
                                        activityData.isStart ||
                                        backgroundOpacity
                                      "
                                      >选择奖品</jd-button
                                    >
                                    <jd-button
                                      type="blueText"
                                      v-if="activityData.isStart"
                                      @click="addStock(scope, index)"
                                      >增加库存</jd-button
                                    >
                                  </template>
                                </el-table-column>
                              </jd-table>
                            </div>
                          </div>
                        </el-form-item>
                      </div>
                    </el-form-item>
                  </div>
                </el-form-item>
              </template>
              <template v-else>
                <el-form-item label="试用订单要求：" required>
                  <div>用户所下订单需满足以下条件</div>
                  <div class="prize_box">
                    <el-form-item
                      label="下单店铺："
                      required
                      label-width="100px"
                    >
                      <orderShopCom
                        :venderIds.sync="
                          purchaseOrderConfig.orderRuleConfig.venderIds
                        "
                        :multiShopGoods.sync="trialMultiShopGoods"
                        :sellerSkuList.sync="
                          purchaseOrderConfig.orderRuleConfig.sellerSkuList
                        "
                        :isDisabled="activityData.isStart"
                      />
                    </el-form-item>
                    <el-form-item
                      label="下单时间："
                      required
                      label-width="100px"
                    >
                      <div class="my_select_time ml8">
                        <el-date-picker
                          prefix-icon="no_icon"
                          v-model="
                            purchaseOrderConfig.orderTimeConfig.startTime
                          "
                          type="datetime"
                          placeholder="开始日期"
                          size="small"
                          format="yyyy-MM-dd HH:mm:ss"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          default-time="00:00:00"
                          style="width: 185px; font-size: 12px"
                          class="time1"
                          :picker-options="orderPickerOptionsStart"
                          :default-time="
                            this.ruleForm.startTime.substring(
                              11,
                              this.$getDate(30)[0].length
                            )
                          "
                          :clearable="false"
                          :disabled="activityData.isStart || backgroundOpacity"
                        >
                        </el-date-picker>
                        <div class="time_to_text">至</div>
                        <el-date-picker
                          prefix-icon="no_icon"
                          v-model="purchaseOrderConfig.orderTimeConfig.endTime"
                          type="datetime"
                          placeholder="结束日期"
                          size="small"
                          format="yyyy-MM-dd HH:mm:ss"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          default-time="23:59:59"
                          :default-time="
                            this.ruleForm.endTime.substring(
                              11,
                              this.$getDate(30)[0].length
                            )
                          "
                          style="width: 200px; font-size: 12px"
                          class="time2"
                          :picker-options="orderPickerOptionsEnd"
                          :clearable="false"
                          :disabled="activityData.isStart || backgroundOpacity"
                        >
                        </el-date-picker>
                        <i
                          class="el-icon-circle-close date_icon1"
                          v-if="!disabled"
                          @click="clearTime()"
                        ></i>
                        <img
                          src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                          alt=""
                          class="date_icon2"
                        />
                      </div>
                    </el-form-item>
                    <el-form-item
                      label="试用商品："
                      required
                      label-width="100px"
                    >
                      <!-- <jd-button
                        @click="isShowTrial = true"
                        :disabled="
                          trialProduct.length == 20 ||
                          activityData.isStart ||
                          backgroundOpacity
                        "
                        >添加商品（{{ trialProduct.length }}/20）</jd-button
                      > -->
                      <productReqCom
                        :venderIds.sync="
                          purchaseOrderConfig.orderRuleConfig.venderIds
                        "
                        :sellerSkuList.sync="
                          purchaseOrderConfig.orderRuleConfig.sellerSkuList
                        "
                        :multiShopGoods.sync="trialMultiShopGoods"
                        :isCreated="isCreated"
                        :isDisabled="activityData.isStart || backgroundOpacity"
                        :isProductReq="false"
                        :limitNum="20"
                        addGoodText="添加商品"
                      >
                        <template #goodsScope="{ scopeItem }">
                          <div
                            class="specified-box flexc-cen-x mt12"
                            v-if="scopeItem.skuIds.length > 0"
                          >
                            <div
                              v-for="(item, index) in scopeItem.itemList"
                              :key="item.skuId"
                              class="prize-item"
                            >
                              <img
                                :src="item.logo"
                                :alt="item.title||item.skuName"
                                class="prize-img"
                              />
                              <img
                                v-if="!activityData.isStart"
                                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/card-delete-icon.svg"
                                class="del-icon"
                                alt=""
                                @click="deletePrize(index, scopeItem)"
                              />
                            </div>
                          </div>
                        </template>
                      </productReqCom>
                    </el-form-item>
                    <el-form-item label="订单状态：" label-width="100px">
                      <el-radio-group v-model="orderStatus">
                        <el-radio :label="0">已完成</el-radio>
                      </el-radio-group>
                      <el-tooltip placement="top">
                        <template #content>
                          <div>订单状态说明：</div>
                          <div>
                            1、已完成：订单确认收货,确认收货后取消订单为售后行为，无法获取取消订单状态
                          </div>
                        </template>
                        <el-button class="ml8" type="text"
                          ><i class="el-icon-question"></i
                        ></el-button>
                      </el-tooltip>
                    </el-form-item>
                  </div>
                </el-form-item>
                <el-form-item label="奖品配置：" required>
                  <el-radio-group
                    v-model="purchaseOrderConfig.prizeConfig.enabled"
                    :disabled="activityData.isStart || backgroundOpacity"
                    @change="handlePrizeConfigChange"
                  >
                    <el-radio :label="false">不设置奖品</el-radio>
                    <el-radio :label="true">设置奖品</el-radio>
                  </el-radio-group>
                  <div
                    class="prize_box"
                    v-if="purchaseOrderConfig.prizeConfig.enabled"
                  >
                    <el-form-item label="奖品发放形式：" label-width="110px">
                      <el-radio-group
                        v-model="purchaseOrderConfig.prizeConfig.sendType"
                        @change="handleSendTypeChange"
                      >
                        <el-radio :label="0">立即发放</el-radio>
                        <el-radio :label="1">
                          <span class="mr8">确认收货</span
                          ><el-input
                            class="w90"
                            v-model="purchaseOrderConfig.prizeConfig.delayDays"
                            @input="
                              purchaseOrderConfig.prizeConfig.delayDays =
                                getNumberData(1, $event, 0, 1, 999999)
                            "
                            :disabled="
                              purchaseOrderConfig.prizeConfig.sendType != 1 ||
                              activityData.isStart ||
                              backgroundOpacity
                            "
                          ></el-input>
                          <span class="ml8">天后发放</span>
                        </el-radio>
                        <el-radio :label="2">
                          <span class="mr8">活动结束</span
                          ><el-input
                            class="w90"
                            v-model="purchaseOrderConfig.prizeConfig.delayDays2"
                            @input="
                              purchaseOrderConfig.prizeConfig.delayDays2 =
                                getNumberData(1, $event, 0, 1, 999999)
                            "
                            :disabled="
                              purchaseOrderConfig.prizeConfig.sendType != 2 ||
                              activityData.isStart ||
                              backgroundOpacity
                            "
                          ></el-input>
                          <span class="ml8">天后发放</span>
                        </el-radio>
                      </el-radio-group>

                      <el-tooltip placement="top">
                        <template #content>
                          <div>
                            1.立即发放:用户下单符合条件后。系统立即发放奖品
                          </div>
                          <div>
                            2.确认收货后发放:用户确认收货满xx天后,商家需自行发货
                          </div>
                          <div>
                            3.活动结束后发放:活动结束x天后，商家需自行发货
                          </div>
                        </template>
                        <el-button class="ml8" type="text">
                          <span>发放规则</span>
                          <i class="el-icon-question"></i
                        ></el-button>
                      </el-tooltip>
                    </el-form-item>
                    <el-form-item
                      label="奖品设置："
                      required
                      label-width="110px"
                    >
                      <jd-button
                        type="blue"
                        @click="addPrizeSetting"
                        :disabled="
                          prizeList.length == 5 ||
                          activityData.isStart ||
                          backgroundOpacity
                        "
                      >
                        +添加奖品（{{ prizeList.length }}/5）</jd-button
                      >
                      <span class="ml8">
                        注：开启配置奖品后，最少配置一个奖品，配置多个奖品时C端用户仅可领取其中一个奖品
                      </span>
                      <div
                        class="prize-set mt12"
                        v-for="(item, index) in prizeList"
                        :key="index"
                      >
                        <i
                          v-if="prizeList.length > 1"
                          class="el-icon-delete delete-icon"
                          @click="deleteStepPrize(index)"
                        ></i>
                        <div>奖品{{ index + 1 }}</div>
                        <div class="ml20">
                          <div class="mb12">
                            <el-form-item
                              label="下单店铺："
                              required
                              label-width="100px"
                            >
                              <orderShopCom
                                :venderIds.sync="item.venderIds"
                                :multiShopGoods.sync="item.multiShopGoods"
                                :sellerSkuList.sync="item.sellerSkuList"
                                :isDisabled="activityData.isStart"
                                :isSingle="true"
                              />
                            </el-form-item>
                            <el-form-item
                              label="购买指定商品："
                              label-width="110px"
                            >
                              <!-- <jd-button
                                :disabled="
                                  item.specifiedProduct.length >= 1 ||
                                  activityData.isStart ||
                                  backgroundOpacity
                                "
                                @click="selectSpecifiedProduct(index)"
                                >选择商品（{{
                                  item.specifiedProduct.length
                                }}/1）</jd-button
                              > -->
                              <!-- <div
                                class="specified-box flexc-cen-x mt12"
                                v-if="item.specifiedProduct.length > 0"
                              >
                                <div
                                  v-for="(row, it) in item.specifiedProduct"
                                  :key="row.skuId + row.title"
                                  class="prize-item"
                                >
                                  <img
                                    :src="row.logo"
                                    :alt="row.title"
                                    class="prize-img"
                                  />
                                  <img
                                    v-if="!activityData.isStart"
                                    src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/card-delete-icon.svg"
                                    class="del-icon"
                                    alt=""
                                    @click="
                                      deleteSpecifiedPrize(
                                        item.specifiedProduct,
                                        it
                                      )
                                    "
                                  />
                                </div>
                              </div> -->
                              <productReqCom
                                :venderIds.sync="item.venderIds"
                                :sellerSkuList.sync="item.sellerSkuList"
                                :multiShopGoods.sync="trialMultiShopGoods"
                                :isCreated="isCreated"
                                :isDisabled="
                                  activityData.isStart || backgroundOpacity
                                "
                                :isProductReq="false"
                                :limitNum="1"
                                addGoodText="选择商品"
                              >
                                <template #goodsScope="{ scopeItem }">
                                  <div
                                    class="specified-box flexc-cen-x mt12"
                                    v-if="scopeItem.skuIds.length > 0"
                                  >
                                    <div
                                      v-for="(
                                        item, index
                                      ) in scopeItem.itemList"
                                      :key="item.skuId + item.title"
                                      class="prize-item"
                                    >
                                      <img
                                        :src="item.logo"
                                        :alt="item.title"
                                        class="prize-img"
                                      />
                                      <img
                                        v-if="!activityData.isStart"
                                        src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/card-delete-icon.svg"
                                        class="del-icon"
                                        alt=""
                                        @click="deletePrize(index, scopeItem)"
                                      />
                                    </div>
                                  </div>
                                </template>
                              </productReqCom>
                            </el-form-item>
                          </div>
                          <jd-table :tableData="item.goodsList">
                            <el-table-column label="奖品类型">
                              <template slot-scope="scope">
                                {{ getPrizeTypeName(scope.row.prizeType) }}
                              </template>
                            </el-table-column>
                            <el-table-column
                              label="奖品价值"
                              prop="price"
                            ></el-table-column>
                            <el-table-column label="图片" width="150">
                              <template slot-scope="scope">
                                <img
                                  v-if="scope.row.logo"
                                  :src="scope.row.logo"
                                  class="prize-logo"
                                />
                              </template>
                            </el-table-column>
                            <el-table-column
                              label="奖品名称（12字内）"
                              min-width="220"
                            >
                              <template slot-scope="scope">
                                <el-input
                                  v-model="scope.row.title"
                                  maxlength="12"
                                  show-word-limit
                                  style="width: 200px"
                                  placeholder="请输入"
                                ></el-input>
                              </template>
                            </el-table-column>
                            <el-table-column label="奖品数量" min-width="140px">
                              <template slot-scope="scope">
                                <el-input
                                  v-model.number="scope.row.totalAmount"
                                  @input.native="
                                    (e) =>
                                      (scope.row.totalAmount = checkputn(
                                        e,
                                        scope.row
                                      ))
                                  "
                                  placeholder="请输入"
                                  @input="
                                    (scope.row.totalAmount = getNumberData(
                                      1,
                                      $event,
                                      0,
                                      1,
                                      999999
                                    )),
                                      prizeNum(scope.row)
                                  "
                                  @blur="beAdd(scope.row)"
                                  :disabled="
                                    (activityData.isStart &&
                                      !scope.row.minNum) ||
                                    activityData.isStart ||
                                    backgroundOpacity|| (scope.row.prizeType == 2 &&scope.row.cycleType==1&&scope.row.totalAmount)
                                  "
                                ></el-input>
                              </template>
                            </el-table-column>

                            <el-table-column
                              label="剩余库存"
                              min-width="140px"
                              v-if="activityData.isStart"
                            >
                              <template slot-scope="scope">
                                <el-input
                                  v-model.number="scope.row.remanentAmount"
                                  style="width: 80px"
                                  disabled
                                ></el-input>
                                份
                              </template>
                            </el-table-column>
                            <el-table-column label="每日发放限额" width="120">
                              <template slot-scope="scope">
                                <dailyLimitConfig
                                  :row="scope.row"
                                  :backgroundOpacity="backgroundOpacity"
                                  :limitBtnDisabled="backgroundOpacity"
                                ></dailyLimitConfig>
                              </template>
                            </el-table-column>
                            <el-table-column label="操作" min-width="120px">
                              <template slot-scope="scope">
                                <jd-button
                                  type="blueText"
                                  @click="
                                    selectGoodFn(item.goodsList, index, scope)
                                  "
                                  :disabled="
                                    activityData.isStart || backgroundOpacity
                                  "
                                  >选择奖品</jd-button
                                >
                                <jd-button
                                  type="blueText"
                                  v-if="activityData.isStart"
                                  @click="addStock(scope, index)"
                                  >增加库存</jd-button
                                >
                              </template>
                            </el-table-column>
                          </jd-table>
                        </div>
                      </div>
                    </el-form-item>
                  </div>
                </el-form-item>
              </template>
            </div>
          </div>
          <div>
            <jd-title label="复购阶段配置" type="bold"></jd-title>
            <div class="mt20">
              <el-form-item label="复购设置：" required>
                <jd-button
                  type="blue"
                  @click="addRePurchaseStage"
                  :disabled="
                    repurchaseStages.length == 10 ||
                    activityData.isStart ||
                    backgroundOpacity
                  "
                >
                  +添加复购阶段（{{ repurchaseStages.length }}/10）
                </jd-button>
                <el-tooltip class="item" effect="dark" placement="top">
                  <template slot="content">
                    <p>
                      1、最少配置一个复购阶段;<br />
                      2、每一阶段的下单开始时间不可早于上一复购阶段下单结束时间，所有阶段下单结束时间不可大于活动结束时间;<br />
                      3、配置相对时间时(满足上一阶段订单条件后N天)需谨慎判断是否C端用户在活动结束前能否完成所有阶段的复购条件；
                    </p>
                  </template>
                  <el-button class="ml8" type="text">
                    <i class="el-icon-question"></i>
                  </el-button>
                </el-tooltip>
                <div class="mt12">
                  <el-tabs
                    v-model="rankValue"
                    closable
                    @tab-remove="removeRank"
                  >
                    <el-tab-pane
                      :key="index"
                      v-for="(item, index) in repurchaseStages"
                      :label="item.stageName"
                      :name="index + ''"
                    >
                      <div class="prize_box">
                        <el-form-item
                          label="阶段名称："
                          required
                          label-width="100px"
                        >
                          <el-input
                            class="w380"
                            maxlength="10"
                            show-word-limit
                            v-model="item.stageName"
                            placeholder="请输入阶段名称"
                          ></el-input>
                        </el-form-item>
                        <el-form-item
                          label="订单规则："
                          required
                          label-width="100px"
                        >
                          <div>用户所下订单需满足以下条件</div>
                          <div class="prize-set">
                            <el-form-item label="下单店铺:" required>
                              <orderShopCom
                                :venderIds.sync="item.orderRuleConfig.venderIds"
                                :multiShopGoods.sync="
                                  item.orderRuleConfig.multiShopGoods
                                "
                                :sellerSkuList.sync="
                                  item.orderRuleConfig.sellerSkuList
                                "
                                :isDisabled="activityData.isStart"
                                @changeShop="changeShopStep($event, index)"
                              />
                            </el-form-item>
                            <el-form-item
                              label="下单时间："
                              required
                              label-width="110px"
                            >
                              <el-select
                                v-model="item.orderTimeConfig.timeType"
                                :disabled="
                                  activityData.isStart || backgroundOpacity
                                "
                                @change="
                                  changeOrderTime($event, item.orderTimeConfig)
                                "
                              >
                                <el-option
                                  label="用户完成上一阶段条件后"
                                  :value="1"
                                ></el-option>
                                <el-option
                                  label="用户在指定时间"
                                  :value="2"
                                ></el-option>
                              </el-select>
                              <el-input
                                v-model="item.orderTimeConfig.joinDays"
                                placeholder="请输入"
                                @input="
                                  item.orderTimeConfig.joinDays = getNumberData(
                                    1,
                                    $event,
                                    0,
                                    1,
                                    999999
                                  )
                                "
                                class="w90 ml8"
                                :disabled="
                                  activityData.isStart || backgroundOpacity
                                "
                                v-if="item.orderTimeConfig.timeType == 1"
                              ></el-input>

                              <div class="my_select_time ml8" v-else>
                                <el-date-picker
                                  prefix-icon="no_icon"
                                  v-model="item.orderTimeConfig.startTime"
                                  type="datetime"
                                  placeholder="开始日期"
                                  size="small"
                                  format="yyyy-MM-dd HH:mm:ss"
                                  value-format="yyyy-MM-dd HH:mm:ss"
                                  default-time="00:00:00"
                                  style="width: 185px; font-size: 12px"
                                  class="time1"
                                  :picker-options="stageOrderPickerOptionsStart"
                                  :default-time="
                                    ruleForm.startTime.substring(
                                      11,
                                      $getDate(30)[0].length
                                    )
                                  "
                                  :clearable="false"
                                  :disabled="
                                    activityData.isStart || backgroundOpacity
                                  "
                                >
                                </el-date-picker>
                                <div class="time_to_text">至</div>
                                <el-date-picker
                                  prefix-icon="no_icon"
                                  v-model="item.orderTimeConfig.endTime"
                                  type="datetime"
                                  placeholder="结束日期"
                                  size="small"
                                  format="yyyy-MM-dd HH:mm:ss"
                                  value-format="yyyy-MM-dd HH:mm:ss"
                                  default-time="23:59:59"
                                  :default-time="
                                    ruleForm.endTime.substring(
                                      11,
                                      $getDate(30)[0].length
                                    )
                                  "
                                  style="width: 200px; font-size: 12px"
                                  class="time2"
                                  :picker-options="stageOrderPickerOptionsEnd"
                                  :clearable="false"
                                  :disabled="
                                    activityData.isStart || backgroundOpacity
                                  "
                                >
                                </el-date-picker>
                                <i
                                  class="el-icon-circle-close date_icon1"
                                  v-if="!disabled"
                                  @click="clearStageTime(item.orderTimeConfig)"
                                ></i>
                                <img
                                  src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                                  alt=""
                                  class="date_icon2"
                                />
                              </div>
                              <span
                                class="ml8"
                                v-if="item.orderTimeConfig.timeType == 1"
                                >天内下单</span
                              >
                            </el-form-item>
                            <el-form-item label="计量单位：" required>
                              <el-radio-group
                                @change="
                                  changeRepurchaseStatisticType($event, item)
                                "
                                v-model="item.orderRuleConfig.statisticType"
                                :disabled="
                                  activityData.isStart || backgroundOpacity
                                "
                              >
                                <el-radio :label="0">按下单金额</el-radio>
                                <el-radio
                                  :label="item.id"
                                  v-for="(row, index) in unitList"
                                  :key="index"
                                  :disabled="
                                    item.orderRuleConfig.venderIds.length > 1
                                  "
                                  >按{{ row.name || "" }}统计</el-radio
                                >
                              </el-radio-group>
                              <jd-tip class="mt5">
                                支持自定义“箱、罐、瓶....”等计量单位，<span
                                  class="goToMeasureUnitText"
                                  @click="goToMeasureUnit"
                                  >去设置计量单位></span
                                >
                              </jd-tip>
                            </el-form-item>
                            <el-form-item label="金额统计类型：" required>
                              <el-radio-group
                                v-model="item.orderRuleConfig.orderPaymentType"
                                :disabled="
                                  activityData.isStart || backgroundOpacity
                                "
                              >
                                <el-radio :label="1">
                                  <span>订单金额（后台价）</span>
                                  <el-tooltip class="item" effect="dark" content="是指京东后台价，不等于商城前台页面展示的价格，前台页面无法查看该后台价格；如需查询后台价格，请联系采销核实。" placement="top-start">
                                    <div class="new-icon-box" style="margin: -3px 8px"></div>
                                  </el-tooltip>
                                </el-radio>
                                <el-radio :label="0" v-if="!isReVenderType(item.orderRuleConfig)">
                                  <span>用户应付金额</span>
                                  <el-tooltip class="item" effect="dark" content="订单商品原价总额-订单优惠总额+订单运费+税费+调整运费金额=用户应付金额" placement="top-start">
                                    <div class="new-icon-box" style="margin: -3px 8px"></div>
                                  </el-tooltip>
                                </el-radio>
                                <el-radio :label="2" v-if="!isReVenderType(item.orderRuleConfig)">
                                  <span>用户实付金额</span>
                                  <el-tooltip class="item" effect="dark" content="用户应付金额-支付优惠总额=用户实付金额" placement="top-start">
                                    <div class="new-icon-box" style="margin: -3px 8px"></div>
                                  </el-tooltip>
                                </el-radio>
                              </el-radio-group>
                              <div class="tips_red">
                                注意：由于接口原因，自营仅支持统计订单金额，pop可按需选择统计实付金额或订单金额。
                              </div>
                            </el-form-item>
                            <el-form-item label="商品要求：" required>
                              <span
                                v-if="item.orderRuleConfig.statisticType != 0"
                              >
                                指定计量单位商品
                              </span>
                              <productReqCom
                                v-else
                                :filterType.sync="
                                  item.orderRuleConfig.filterType
                                "
                                :venderIds.sync="item.orderRuleConfig.venderIds"
                                :sellerSkuList.sync="
                                  item.orderRuleConfig.sellerSkuList
                                "
                                :multiShopGoods.sync="item.multiShopGoods"
                                :isCreated="isCreated"
                                :isDisabled="activityData.isStart"
                                addGoodText="已选商品"
                              />
                              <!-- <el-radio-group
                                v-else
                                v-model="item.orderRuleConfig.filterType"
                                :disabled="
                                  activityData.isStart || backgroundOpacity || item.orderRuleConfig.statisticType != 0
                                "
                                @change="changeFilterType(item.orderRuleConfig)"
                              >
                                <el-radio :label="0">全部商品</el-radio>
                                <el-radio :label="1">指定商品</el-radio>
                                <el-radio :label="2">排除商品</el-radio>
                              </el-radio-group> -->
                              <jd-button
                                class="ml8"
                                v-if="item.orderRuleConfig.statisticType != 0"
                                @click="
                                  openStepSpecify(
                                    item.orderRuleConfig.skuIdList,
                                    item
                                  )
                                "
                                :disabled="
                                  item.orderRuleConfig.filterType == 0 ||
                                  activityData.isStart
                                "
                                >已选商品{{
                                  item.orderRuleConfig.skuIdList.length
                                }}个</jd-button
                              >
                            </el-form-item>
                            <el-form-item label="指定商品规则:" v-if="item.orderRuleConfig.orderPaymentType==1&&item.orderRuleConfig.filterType == 1">
                              <el-select style="width: 280px;" v-model="item.orderRuleConfig.filterSkuType" :disabled="activityData.isStart" placeholder="">
                                <el-option label="只要订单包含指定商品就整单计算" :value="0"></el-option>
                                <el-option label="仅统计订单内指定商品的金额和件数" :value="1"></el-option>
                              </el-select>
                              <jd-button type="blueText" class="ml12" @click="viewStatisticsLogic">查看统计逻辑</jd-button>
                            </el-form-item>
                            <el-form-item label="订单状态：" required>
                              <el-radio-group
                                v-model="orderStatus"
                                :disabled="
                                  activityData.isStart || backgroundOpacity
                                "
                              >
                                <el-radio :label="0">已完成</el-radio>
                              </el-radio-group>
                              <el-tooltip placement="top">
                                <template #content>
                                  <div>订单状态说明：</div>
                                  <div>
                                    1、已完成：订单确认收货,确认收货后取消订单为售后行为，无法获取取消订单状态
                                  </div>
                                </template>
                                <el-button class="ml8" type="text"
                                  ><i class="el-icon-question"></i
                                ></el-button>
                              </el-tooltip>
                            </el-form-item>
                            <el-form-item label="订单拆单后是否合并:" label-width="160px" required>
                              <el-radio-group
                                :disabled="activityData.isStart"
                                v-model="item.orderRuleConfig.mergeOrder"
                              >
                                <el-radio :label="false">否</el-radio>
                                <el-radio :label="true">是</el-radio>
                              </el-radio-group>
                              <jd-button type="blueText" class="ml12" @click="viewMergeLogic">查看合并拆单逻辑</jd-button>
                            </el-form-item>
                          </div>
                        </el-form-item>
                        <el-form-item
                          label="奖品配置："
                          required
                          label-width="100px"
                        >
                          <div>活动期间每个复购阶段C端用户一个奖品</div>
                          <div>
                            <el-form-item
                              label="奖品发放形式："
                              label-width="110px"
                            >
                              <el-radio-group
                                v-model="item.prizeConfig.sendType"
                                :disabled="
                                  activityData.isStart || backgroundOpacity
                                "
                                @change="
                                  changeStepSendType($event, item.prizeConfig)
                                "
                              >
                                <el-radio :label="0">立即发放</el-radio>
                                <el-radio :label="1">
                                  <span class="mr8">确认收货</span
                                  ><el-input
                                    class="w90"
                                    v-model="item.prizeConfig.delayDays"
                                    @input="
                                      item.prizeConfig.delayDays =
                                        getNumberData(1, $event, 0, 1, 999999)
                                    "
                                    :disabled="
                                      item.prizeConfig.sendType != 1 ||
                                      activityData.isStart ||
                                      backgroundOpacity
                                    "
                                  ></el-input>
                                  <span class="ml8">天后发放</span>
                                </el-radio>
                                <el-radio :label="2">
                                  <span class="mr8">活动结束</span
                                  ><el-input
                                    class="w90"
                                    v-model="item.prizeConfig.delayDays2"
                                    @input="
                                      item.prizeConfig.delayDays2 =
                                        getNumberData(1, $event, 0, 1, 999999)
                                    "
                                    :disabled="
                                      item.prizeConfig.sendType != 2 ||
                                      activityData.isStart ||
                                      backgroundOpacity
                                    "
                                  ></el-input>
                                  <span class="ml8">天后发放</span>
                                </el-radio>
                              </el-radio-group>

                              <el-tooltip placement="top">
                                <template #content>
                                  <div>
                                    1.立即发放:用户下单符合条件后。系统立即发放奖品
                                  </div>
                                  <div>
                                    2.确认收货后发放:用户确认收货满xx天后,商家需自行发货
                                  </div>
                                  <div>
                                    3.活动结束后发放:活动结束x天后，商家需自行发货
                                  </div>
                                </template>
                                <el-button class="ml8" type="text">
                                  <span>发放规则</span>
                                  <i class="el-icon-question"></i
                                ></el-button>
                              </el-tooltip>
                            </el-form-item>
                            <el-form-item
                              label="奖品设置："
                              required
                              label-width="110px"
                            >
                              <jd-button
                                type="blue"
                                @click="addStepPrizeSetting(item)"
                                :disabled="
                                  item.stepPrizeList.length == 5 ||
                                  activityData.isStart ||
                                  backgroundOpacity
                                "
                              >
                                +添加奖品（{{
                                  item.stepPrizeList.length
                                }}/5）</jd-button
                              >
                              <span class="ml8">
                                注：开启配置奖品后，最少配置一个奖品
                              </span>
                              <div
                                class="prize-set mt12"
                                v-for="(row, it) in item.stepPrizeList"
                                :key="it"
                              >
                                <i
                                  v-if="item.stepPrizeList.length > 1"
                                  class="el-icon-delete delete-icon"
                                  @click="deleteRepurchasePrize(item, it)"
                                ></i>
                                <div>奖品{{ it + 1 }}</div>
                                <div class="ml20">
                                  <div class="mb12">
                                    <span class="mr8"
                                      >消费门槛：
                                      {{
                                        item.orderRuleConfig.statisticType == 0
                                          ? "金额"
                                          : unitList.find(
                                              (v) =>
                                                v.id ==
                                                item.orderRuleConfig
                                                  .statisticType
                                            )
                                          ? unitList.find(
                                              (v) =>
                                                v.id ==
                                                item.orderRuleConfig
                                                  .statisticType
                                            ).name + "数"
                                          : ""
                                      }}≥
                                    </span>
                                    <el-input
                                      v-model="row.orderAmtLimit"
                                      placeholder="请输入"
                                      class="w90"
                                      @input="
                                        row.orderAmtLimit = getNumberData(
                                          1,
                                          $event,
                                          1,
                                          0,
                                          999999
                                        )
                                      "
                                      :disabled="
                                        activityData.isStart ||
                                        backgroundOpacity
                                      "
                                    ></el-input>
                                    <span class="ml8">
                                      {{
                                        unitList &&
                                        unitList.find(
                                          (v) =>
                                            v.id ==
                                            item.orderRuleConfig.statisticType
                                        )
                                          ? unitList.find(
                                              (v) =>
                                                v.id ==
                                                item.orderRuleConfig
                                                  .statisticType
                                            ).name
                                          : "元"
                                      }} </span
                                    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <span
                                      style="color: red"
                                      v-if="activityData.isStart"
                                      >提示：修改奖品名称后，已领取的奖品记录依旧不变更名称</span
                                    >
                                  </div>
                                  <jd-table :tableData="row.goodsList">
                                    <el-table-column
                                      label="奖品类型"
                                      min-width="100px"
                                    >
                                      <template slot-scope="scope">
                                        {{
                                          getPrizeTypeName(scope.row.prizeType)
                                        }}
                                      </template>
                                    </el-table-column>
                                    <el-table-column
                                      label="奖品价值"
                                      prop="price"
                                      min-width="120px"
                                    ></el-table-column>
                                    <el-table-column
                                      label="图片"
                                      min-width="100px"
                                    >
                                      <template slot-scope="scope">
                                        <img
                                          v-if="scope.row.logo"
                                          :src="scope.row.logo"
                                          class="prize-logo"
                                        />
                                      </template>
                                    </el-table-column>
                                    <el-table-column
                                      label="奖品名称（12字内）"
                                      min-width="200px"
                                    >
                                      <template slot-scope="scope">
                                        <el-input
                                          v-model="scope.row.title"
                                          maxlength="12"
                                          show-word-limit
                                          style="width: 200px"
                                          placeholder="请输入"
                                        ></el-input>
                                      </template>
                                    </el-table-column>
                                    <el-table-column
                                      label="奖品数量"
                                      prop="num"
                                      min-width="100px"
                                    >
                                      <template slot-scope="scope">
                                        <el-input
                                          v-model.number="scope.row.totalAmount"
                                          @input.native="
                                            (e) =>
                                              (scope.row.totalAmount =
                                                checkputn(e, scope.row))
                                          "
                                          placeholder="请输入"
                                          @input="
                                            (scope.row.totalAmount =
                                              getNumberData(
                                                1,
                                                $event,
                                                0,
                                                1,
                                                999999
                                              )),
                                              prizeNum(scope.row)
                                          "
                                          @blur="beAdd(scope.row)"
                                          :disabled="
                                            (activityData.isStart &&
                                              !scope.row.minNum) ||
                                            activityData.isStart ||
                                            backgroundOpacity || (scope.row.prizeType == 2 &&scope.row.cycleType==1&&scope.row.totalAmount)
                                          "
                                        ></el-input>
                                      </template>
                                    </el-table-column>
                                    <el-table-column
                                      label="剩余库存"
                                      min-width="100px"
                                      v-if="activityData.isStart"
                                    >
                                      <template slot-scope="scope">
                                        <el-input
                                          v-model.number="
                                            scope.row.remanentAmount
                                          "
                                          style="width: 80px"
                                          disabled
                                        ></el-input>
                                        份
                                      </template>
                                    </el-table-column>
                                    <el-table-column
                                      label="每日发放限额"
                                      width="120"
                                    >
                                      <template slot-scope="scope">
                                        <dailyLimitConfig
                                          :row="scope.row"
                                          :backgroundOpacity="backgroundOpacity"
                                          :limitBtnDisabled="backgroundOpacity"
                                        ></dailyLimitConfig>
                                      </template>
                                    </el-table-column>
                                    <el-table-column
                                      label="操作"
                                      min-width="120px"
                                    >
                                      <template slot-scope="scope">
                                        <jd-button
                                          type="blueText"
                                          @click="
                                            selectRepurchaseGoodFn(
                                              row.goodsList,
                                              it,
                                              scope
                                            )
                                          "
                                          :disabled="
                                            activityData.isStart ||
                                            backgroundOpacity
                                          "
                                          >选择奖品</jd-button
                                        >
                                        <jd-button
                                          type="blueText"
                                          v-if="activityData.isStart"
                                          @click="
                                            addRepurchaseStock(scope, index, it)
                                          "
                                          >增加库存</jd-button
                                        >
                                      </template>
                                    </el-table-column>
                                  </jd-table>
                                </div>
                              </div>
                            </el-form-item>
                          </div>
                        </el-form-item>
                      </div>
                    </el-tab-pane>
                  </el-tabs>
                </div>
              </el-form-item>
            </div>
          </div>
          <activityPageSettings
            isShowShopName
            isShowShopNameByChannel
            isShowMoreSet
            :cusTemplateJSON.sync="ruleDTO.cusTemplateJSON"
            :isNeedSetBG="true"
            :giftList="giftList"
            themeTitle="主题"
            :templateId="templateId"
            @selectTemplate="selectTemplate"
            :widthNumber="750"
            :heightNumber="2262"
            previewKey="url"
            templatekey="imageUrl"
            :isShowDesignNumber="false"
            :isCustomPreview="true"
            :defaultRgb="currrentRgb"
            downloadTemplateUrl="https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/member-growth-program.psd"
            :designSpecificationsUrl="designSpecificationsList[activityData.id]"
            v-model="customerPaperwork"
          >
            <template #customPreview>
              <lifeCyclePreviewDialog
                :backgroundImage="templateObj.url"
                :ruleDTO="ruleDTO"
                :customerPaperwork="customerPaperwork"
                :templateObj="templateObj"
                :repurchaseStages="repurchaseStages"
                :firstStageConfig="firstStageConfig"
                :designatedSku="designatedSku"
                :prizeList="prizeList"
                :purchaseOrderConfig="purchaseOrderConfig"
                :trialProduct="purchaseOrderConfig.orderRuleConfig.sellerSkuList.length>0?purchaseOrderConfig.orderRuleConfig.sellerSkuList[0].itemList:[]"
              ></lifeCyclePreviewDialog>
            </template>
            <template #otherSet>
              <div class="ui-box">
                <el-form-item
                  label="试用商品模块背景图："
                  label-width="180px"
                  v-if="ruleDTO.activityScene == 2"
                >
                  <div class="buttonGroup">
                    <el-upload
                      class="upload"
                      action="/jd-hd-web/image/upload"
                      :show-file-list="false"
                      :before-upload="(file) => beforeUploadUI(file, 5)"
                      :on-success="(res) => handleUploadUI(res, 5)"
                    >
                      <div
                        class="btn-bg"
                        v-if="customerPaperwork.trialModelUrl"
                      >
                        <img
                          :src="customerPaperwork.trialModelUrl"
                          style="width: 100%; height: auto"
                        />
                      </div>
                      <jd-button
                        v-else
                        type="blueText"
                        label="自定义上传"
                        :disabled="backgroundOpacity"
                      ></jd-button>
                    </el-upload>
                    <jd-button
                      type="blueText"
                      @click="customerPaperwork.trialModelUrl = ''"
                      style="margin: 0 16px 0 16px"
                      :disabled="backgroundOpacity"
                      >重置</jd-button
                    >
                  </div>
                </el-form-item>
                <template v-else>
                  <el-form-item
                    label="会员专属价模块背景图："
                    label-width="180px"
                  >
                    <div class="buttonGroup">
                      <el-upload
                        class="upload"
                        action="/jd-hd-web/image/upload"
                        :show-file-list="false"
                        :before-upload="(file) => beforeUploadUI(file, 1)"
                        :on-success="(res) => handleUploadUI(res, 1)"
                      >
                        <div
                          class="btn-bg"
                          v-if="customerPaperwork.memberModelUrl"
                        >
                          <img
                            :src="customerPaperwork.memberModelUrl"
                            style="width: 100%; height: auto"
                          />
                        </div>
                        <jd-button
                          v-else
                          type="blueText"
                          label="自定义上传"
                          :disabled="backgroundOpacity"
                        ></jd-button>
                      </el-upload>
                      <jd-button
                        type="blueText"
                        @click="customerPaperwork.memberModelUrl = ''"
                        style="margin: 0 16px 0 16px"
                        :disabled="backgroundOpacity"
                        >重置</jd-button
                      >
                    </div>
                  </el-form-item>
                  <el-form-item
                    label="会员专属价文案颜色："
                    label-width="180px"
                  >
                    <div class="buttonGroup">
                      <el-color-picker
                        v-model="customerPaperwork.memberWordColor"
                        size="small"
                      ></el-color-picker>
                      <jd-button
                        type="blueText"
                        style="margin: 0 12px 0 16px"
                        @click="
                          customerPaperwork.memberWordColor = currrentRgb2
                        "
                        :disabled="backgroundOpacity"
                        >重置</jd-button
                      >
                    </div>
                  </el-form-item>
                  <el-form-item
                    label="会员专属价按钮背景图："
                    label-width="180px"
                  >
                    <div class="buttonGroup">
                      <el-upload
                        class="upload"
                        action="/jd-hd-web/image/upload"
                        :show-file-list="false"
                        :before-upload="(file) => beforeUploadUI(file, 2)"
                        :on-success="(res) => handleUploadUI(res, 2)"
                      >
                        <div
                          class="btn-bg"
                          v-if="customerPaperwork.memberBtnUrl"
                        >
                          <img
                            :src="customerPaperwork.memberBtnUrl"
                            style="width: 100%; height: auto"
                          />
                        </div>
                        <jd-button
                          v-else
                          type="blueText"
                          label="自定义上传"
                          :disabled="backgroundOpacity"
                        ></jd-button>
                      </el-upload>
                      <jd-button
                        type="blueText"
                        @click="customerPaperwork.memberBtnUrl = ''"
                        style="margin: 0 16px 0 16px"
                        :disabled="backgroundOpacity"
                        >重置</jd-button
                      >
                    </div>
                  </el-form-item>
                  <el-form-item
                    label="会员专属价按钮文案颜色："
                    label-width="180px"
                  >
                    <div class="buttonGroup">
                      <el-color-picker
                        v-model="customerPaperwork.memberBtnWordColor"
                        size="small"
                      ></el-color-picker>
                      <jd-button
                        type="blueText"
                        style="margin: 0 12px 0 16px"
                        @click="
                          customerPaperwork.memberBtnWordColor = currrentRgb3
                        "
                        :disabled="backgroundOpacity"
                        >重置</jd-button
                      >
                    </div>
                  </el-form-item>
                </template>
                <el-form-item label="奖品模块背景图：" label-width="180px">
                  <div class="buttonGroup">
                    <el-upload
                      class="upload"
                      action="/jd-hd-web/image/upload"
                      :show-file-list="false"
                      :before-upload="(file) => beforeUploadUI(file, 3)"
                      :on-success="(res) => handleUploadUI(res, 3)"
                    >
                      <div
                        class="btn-bg"
                        v-if="customerPaperwork.prizeModelUrl"
                      >
                        <img
                          :src="customerPaperwork.prizeModelUrl"
                          style="width: 100%; height: auto"
                        />
                      </div>
                      <jd-button
                        v-else
                        type="blueText"
                        label="自定义上传"
                        :disabled="backgroundOpacity"
                      ></jd-button>
                    </el-upload>
                    <jd-button
                      type="blueText"
                      @click="customerPaperwork.prizeModelUrl = ''"
                      style="margin: 0 16px 0 16px"
                      :disabled="backgroundOpacity"
                      >重置</jd-button
                    >
                  </div>
                </el-form-item>
                <el-form-item label="模块内文案颜色：" label-width="180px">
                  <div class="buttonGroup">
                    <el-color-picker
                      v-model="customerPaperwork.modelWordColor"
                      size="small"
                    ></el-color-picker>
                    <jd-button
                      type="blueText"
                      style="margin: 0 12px 0 16px"
                      @click="customerPaperwork.modelWordColor = currrentRgb4"
                      :disabled="backgroundOpacity"
                      >重置</jd-button
                    >
                  </div>
                </el-form-item>
                <el-form-item label="阶段tab背景图：" label-width="180px">
                  <div class="buttonGroup">
                    <el-upload
                      class="upload"
                      action="/jd-hd-web/image/upload"
                      :show-file-list="false"
                      :before-upload="(file) => beforeUploadUI(file, 4)"
                      :on-success="(res) => handleUploadUI(res, 4)"
                    >
                      <div class="btn-bg" v-if="customerPaperwork.stepTabUrl">
                        <img
                          :src="customerPaperwork.stepTabUrl"
                          style="width: 100%; height: auto"
                        />
                      </div>
                      <jd-button
                        v-else
                        type="blueText"
                        label="自定义上传"
                        :disabled="backgroundOpacity"
                      ></jd-button>
                    </el-upload>
                    <jd-button
                      type="blueText"
                      @click="customerPaperwork.stepTabUrl = ''"
                      style="margin: 0 16px 0 16px"
                      :disabled="backgroundOpacity"
                      >重置</jd-button
                    >
                  </div>
                </el-form-item>
                <el-form-item
                  label="阶段进度条颜色（左）："
                  label-width="180px"
                >
                  <div class="buttonGroup">
                    <el-color-picker
                      v-model="customerPaperwork.progressLeftColor"
                      size="small"
                    ></el-color-picker>
                    <jd-button
                      type="blueText"
                      style="margin: 0 12px 0 16px"
                      @click="
                        customerPaperwork.progressLeftColor = currrentRgb5
                      "
                      :disabled="backgroundOpacity"
                      >重置</jd-button
                    >
                  </div>
                </el-form-item>
                <el-form-item
                  label="阶段进度条颜色（中）："
                  label-width="180px"
                >
                  <div class="buttonGroup">
                    <el-color-picker
                      v-model="customerPaperwork.progressMiddleColor"
                      size="small"
                    ></el-color-picker>
                    <jd-button
                      type="blueText"
                      style="margin: 0 12px 0 16px"
                      @click="
                        customerPaperwork.progressMiddleColor = currrentRgb6
                      "
                      :disabled="backgroundOpacity"
                      >重置</jd-button
                    >
                  </div>
                </el-form-item>
                <el-form-item
                  label="阶段进度条颜色（右）："
                  label-width="180px"
                >
                  <div class="buttonGroup">
                    <el-color-picker
                      v-model="customerPaperwork.progressRightColor"
                      size="small"
                    ></el-color-picker>
                    <jd-button
                      type="blueText"
                      style="margin: 0 12px 0 16px"
                      @click="
                        customerPaperwork.progressRightColor = currrentRgb7
                      "
                      :disabled="backgroundOpacity"
                      >重置</jd-button
                    >
                  </div>
                </el-form-item>
              </div>
            </template>
          </activityPageSettings>
          <jd-title label="进店设置" type="bold"></jd-title>
          <el-form-item label="进店逛逛:">
            <el-radio-group
              v-model="ruleDTO.goShopSetting"
              :disabled="activityData.isStart"
              @change="onShopSetChange"
            >
              <el-radio :label="0">进入店铺首页</el-radio>
              <el-radio :label="1">跳转指定小程序</el-radio>
              <el-radio :label="2">进入指定链接</el-radio>
            </el-radio-group>
            <div style="color: #f56c6c">
              部分活动需要配合曝光商品使用，如幸运抽奖、裂变神券
            </div>
          </el-form-item>
          <div v-if="ruleDTO.goShopSetting == 1">
            <el-form-item label="小程序appId:" required>
              <el-input
                type="textarea"
                placeholder="请输入小程序appId"
                style="width: 425px; margin-left: 8px"
                show-word-limit
                v-model="ruleDTO.goShopAppId"
                :maxlength="1000"
                :disabled="activityData.isStart"
              ></el-input>
            </el-form-item>
            <el-form-item label="页面路径path:">
              <el-input
                type="textarea"
                placeholder="请输入小程序页面路径path"
                style="width: 425px; margin-left: 8px"
                show-word-limit
                v-model="ruleDTO.goShopUrl"
                :maxlength="1000"
                :disabled="activityData.isStart"
              ></el-input>
              <div style="color: #f56c6c">
                注意：path若不写，则默认进入小程序主页。
              </div>
            </el-form-item>
          </div>
          <el-form-item
            label="指定链接:"
            required
            v-if="ruleDTO.goShopSetting == 2"
          >
            <el-input
              type="textarea"
              placeholder="请输入指定链接"
              style="width: 425px; margin-left: 8px"
              show-word-limit
              v-model="ruleDTO.goShopUrl"
              :maxlength="1000"
              :disabled="activityData.isStart"
            ></el-input>
            <div style="color: #f56c6c">
              注意：仅可填写京东域内的
              H5页面地址，不可设置外链。参考链接：https://m.jd.com/。
            </div>
          </el-form-item>
          <exposureList
            :defaultExposureSwitch.sync="ruleForm.isExposureItem"
            v-model="itemListFor"
            :backgroundOpacity="backgroundOpacity"
            :isLimit="true"
            :isEdit="isCreated"
            :multiShopSkuType.sync="multiShopSkuType"
            :multiShopGoods="expoMultiShopGoods"
            :skuBelongVenderId="skuBelongVenderId"
          ></exposureList>
          <sharFrom :sharePic="sharePic" v-model="ruleDTO"></sharFrom>
          <activityRules
            :isForceRemind.sync="isForceRemind"
            :isKeyActivity.sync="isKeyActivity"
            :placementPosition.sync="placementPosition"
            v-model="ruleForm.ruleDescription"
            :activityData="activityData"
            :valueRow="valueRow"
            @generateRule="generateRule"
          ></activityRules>
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStepNum == 0 || localStepNum == 1">
      <jd-button
        v-if="localStepNum != 0"
        v-show="!itemId"
        style="margin-right: 8px"
        @click="clickLocalStep()"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</jd-button
      >
      <jd-button @click="saveDraft" style="margin-right: 8px" v-if="hasDraftBtn"
        >保存至草稿箱</jd-button
      >
      <template v-if="!backgroundOpacity">
        <jd-button
          v-show="!itemId"
          v-if="isSave"
          type="blue"
          @click="resetForm"
          v-preventReClick
          >保存设置</jd-button
        >
      </template>

      <jd-button v-show="itemId" style="margin-right: 8px" @click="cancelEdit"
        >取消</jd-button
      >
      <jd-button v-show="itemId" type="blue">保存设置</jd-button>
    </div>

    <!-- 保存设置弹框 -->
    <el-dialog
      title="重要提示"
      :visible.sync="joinBlackList"
      width="800"
      @close="checked = false"
    >
      <div v-loading="saveLoading">
        <div style="line-height: 25px; margin-bottom: 30px">
          <p>
            1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
          </p>
          <p>
            2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
          </p>
        </div>

        <el-checkbox v-model="checked" label="地址" name="partner"
          >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
        >
      </div>
      <div slot="footer" class="dialog-footer">
        <jd-button @click="joinBlackList = false">取 消</jd-button>
        <jd-button
          @click="handleDialogCloseAnoth()"
          type="blue"
          style="margin-left: 8px"
          v-loading="saveLoading"
          >确 定</jd-button
        >
      </div>
    </el-dialog>
    <!-- 增加奖品弹窗 -->
    <addPrizeNum
      :isShowAddNum="isShowAddNum"
      :prizeData="toAddItem"
      @confirm="confirmAdd"
      @close="isShowAddNum = false"
    />
    <!-- 奖品弹窗 -->
    <selectProduct
      ref="selectProduct"
      v-if="isShowPrize"
      :echoDate="echoDate"
      :num="1"
      :actId="valueRow"
      :JingdouCount="JingdouCount"
      :typeDefault="typeDefault"
      :actType="68"
      :actEndTime="ruleForm.endTime"
      @choose-shop="getTheData"
    >
    </selectProduct>
    <!-- 复购奖品弹窗 -->
    <selectProduct
      ref="selectStepProduct"
      v-if="isShowStepPrize"
      :echoDate="echoDate"
      :num="1"
      :actId="valueRow"
      :JingdouCount="JingdouCount"
      :typeDefault="typeDefault"
      :actType="68"
      :actEndTime="ruleForm.endTime"
      @choose-shop="getStepTheData"
    >
    </selectProduct>
    <!-- 专享价 -->
    <selectSpecialDialog
      v-if="isShowExclusive"
      v-model="isShowExclusive"
      :exclusivePriceId="promotionId"
      @confirm="confirmExclusiveOrToken"
    ></selectSpecialDialog>
    <!-- 试用商品 -->
    <selectGoods
      v-if="isShowTrial"
      :isShow="isShowTrial"
      @close="getTrialProduct"
      :selectGoods="trialProduct"
      :moduleType="true"
      :skuSearch="true"
      :isLimit="true"
      :limitNum="20"
      :disabled="backgroundOpacity"
    >
    </selectGoods>
    <!--试用正装： 购买指定商品 -->
    <selectGoods
      v-if="isShowSpecified"
      :isShow="isShowSpecified"
      @close="getSpecifiedProduct"
      :selectGoods="specifiedProduct"
      :moduleType="true"
      :skuSearch="true"
      :isLimit="true"
      :limitNum="1"
      :disabled="backgroundOpacity"
    >
    </selectGoods>
    <!-- 会员首购：指定商品 -->
    <selectGoods
      v-if="isShowSpecify"
      :isShow="isShowSpecify"
      @close="getSpecifyOrExcludeGoods"
      :selectGoods="specifyOrExcludeGoods"
      :hasSelectGoods="hasSelectGoods"
      :isClear="activityData.isStart"
      :moduleType="true"
      :skuSearch="true"
      :disabled="backgroundOpacity"
    ></selectGoods>
    <!-- 复购阶段：指定商品 -->
    <selectGoods
      v-if="isShowStepSpecify"
      :isShow="isShowStepSpecify"
      @close="getStepSpecifyOrExcludeGoods"
      :selectGoods="stepspecifyOrExcludeGoods"
      :moduleType="true"
      :skuSearch="true"
      :disabled="backgroundOpacity"
    ></selectGoods>
    <!-- 选择令牌弹窗 -->
    <selectTokenDialog
      v-if="isShowToken"
      v-model="isShowToken"
      :tokenId="promotionId"
      @confirm="confirmExclusiveOrToken"
      :isSetDisabled="true"
    ></selectTokenDialog>
    <!-- 自定义计量单位-首购 -->
    <select-unit-goods
      v-if="isShowSelectUnitGoods"
      :skuSearch="true"
      :isShow="isShowSelectUnitGoods"
      :moduleType="true"
      :selectGoods="specifyOrExcludeGoods"
      :measureUnitId="purchaseOrderConfig.orderRuleConfig.statisticType"
      @close="getSpecifyOrExcludeGoods"
      isInteract
    ></select-unit-goods>
    <!-- 自定义计量单位-复购 -->
    <select-unit-goods
      v-if="isShowSelectUnitGoods2"
      :skuSearch="true"
      :isShow="isShowSelectUnitGoods2"
      :moduleType="true"
      :selectGoods="stepspecifyOrExcludeGoods"
      :measureUnitId="stepspecifyItem.orderRuleConfig.statisticType"
      @close="getStepSpecifyOrExcludeGoods"
    ></select-unit-goods>
  </div>
</template>

<script>
import selectGoods from "@/components/selectGoodsMonitor2";
import selectUnitGoods from "@/views/interactiveMarketing/activity/components/selectUnitGoods.vue";
import selectProduct from "./select_product_componentization.vue";
import {
  saveActivityCommon,
  getActivityDetailCommon,
} from "@/api/jhk/integralCenter/PointActivityAnalyticController.js";
import { sellerImage } from "@/api/jhk/paradiseAndTaskCommonController.js";
import { updateCommon } from "@/api/jhk/integralCenter/integralTask";
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import draggable from "vuedraggable";
import addPrizeNum from "./components/add-prize-num.vue";
import setLimitDialog from "@/views/interactiveMarketing/activity/components/_components/setLimitDialog.vue";
import informationForm from "./components/informationForm.vue";
import exposureList from "./components/exposureList.vue";
import sharFrom from "./components/sharFrom.vue";
import activityRules from "./components/activityRules.vue";
import activityPageSettings from "./components/activityPageSettings.vue";
import addTaskDialog from "./components/unlock_task_dialog.vue";
import lifeCyclePreviewDialog from "./components/newActPreviews/lifeCycle-preview-dialog.vue";
import selectSpecialDialog from "./components/selectSpecialDialog.vue";
import selectTokenDialog from "@/views/interactiveMarketing/promo/components/selectTokenDialog.vue";
import { getTaobaoItemListSku } from "@/api/jhk/analysis/ware-controller";
import { measureUnitPage, unitSkuPage } from "@/api/measuringUnit.js";
import dailyLimitConfig from "@/views/interactiveMarketing/activity/components/dailyLimitConfig.vue";
import orderShopCom from "@/views/interactiveMarketing/activity/components/multipleStoreSetting/orderShopCom.vue";
import productReqCom from "@/views/interactiveMarketing/activity/components/multipleStoreSetting/productReqCom.vue";
import { useValidateMultiShopGoods, useValidateMoreActSet } from "@/views/interactiveMarketing/activity/components/commDataHook/useBasicInformation.js";
export default {
  components: {
    selectGoods,
    selectProduct,
    draggable,
    addPrizeNum,
    setLimitDialog,
    informationForm,
    exposureList,
    sharFrom,
    activityRules,
    activityPageSettings,
    addTaskDialog,
    lifeCyclePreviewDialog,
    selectSpecialDialog,
    selectTokenDialog,
    selectUnitGoods,
    dailyLimitConfig,
    orderShopCom,
    productReqCom,
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activityData: {
      type: Object,
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    valueRow: {
      type: Object,
      default: () => {},
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    venderType: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.purchaseOrderConfig.orderRuleConfig.orderPaymentType = 1;
          this.repurchaseStages.forEach((item) => {
            item.orderRuleConfig.orderPaymentType = 1;
          });
        }
      },
      immediate: true,
    },
    // 只选pop店铺
    // isPop(newVal) {
    //   if (newVal) {
    //     this.purchaseOrderConfig.orderRuleConfig.orderPaymentType = 0;
    //   } 
    //   else {
    //     this.purchaseOrderConfig.orderRuleConfig.orderPaymentType = 1;
    //   }
    // },
    //自营和pop店铺其中一个或只有自营
    isVenderType(newVal) {
      if (newVal) {
        this.purchaseOrderConfig.orderRuleConfig.orderPaymentType = 1;
      } 
      // else {
      //   this.purchaseOrderConfig.orderRuleConfig.orderPaymentType = 0;
      // }
    },
    "$store.state.shopList"(newList) {
      if (newList && newList.length) {
        this.orderMultiShopGoods = this.purchaseOrderConfig.orderRuleConfig.venderIds &&
        this.purchaseOrderConfig.orderRuleConfig.venderIds.length > 0
          ? useValidateMultiShopGoods(
              this,
              this.purchaseOrderConfig.orderRuleConfig.venderIds
            )
          : useValidateMultiShopGoods(this, [this.venderId]);
      }
    },
  },
  data() {
    return {
      expoMultiShopGoods: [],
      multiShopSkuType: 0,
      skuBelongVenderId: "",
      trialMultiShopGoods: [],
      isCreated: false,
      orderMultiShopGoods: [],
      isKeyActivity: 0,
      placementPosition: [],
      isShowSelectUnitGoods2: false,
      stepspecifyItem: {},
      isShowSelectUnitGoods: false,
      isSignLimitTime: false, // 报名限制时间
      designatedSkuCopy: [],
      currentId: null,
      defaultLogo: "https://cdn-image.yucrm.cn/hd/images/prizeShow646.png",
      hasSelectGoods: [],
      currentPrizeIndex: -1,
      stockType: 0,
      stockIndex: 0,
      stockPrizeIndex: 0,
      isShowStepPrize: false,
      stepCurrentIndex: 0,
      stepPrizeIndex: 0,
      isShowStepSpecify: false,
      stepspecifyOrExcludeGoods: [],
      rankValue: 0, // 复购阶段配置值
      repurchaseStages: [
        {
          stageName: "第1次复购",
          orderTimeConfig: {
            timeType: 1,
            joinDays: null,
            startTime: "",
            endTime: "",
          },
          orderRuleConfig: {
            orderPaymentType: 1,
            filterType: 0,
            skuIdList: [],
            statisticType: 0, // 0-按下单金额 1-自定义计量单位
            venderIds: [],
            sellerSkuList: [],
            multiShopGoods: [],
            filterSkuType: 0,
            mergeOrder: false,
          },
          prizeConfig: {
            enabled: true,
            sendType: 0,
            delayDays: null,
            delayDays2: null,
          },
          stepPrizeList: [
            {
              orderAmtLimit: null,
              goodsList: [
                {
                  assetsId: "",
                  title: "",
                  logo: "",
                  prize: "",
                  prizeType: null,
                  totalAmount: null,
                },
              ],
            },
            {
              orderAmtLimit: null,
              goodsList: [
                {
                  assetsId: "",
                  title: "",
                  logo: "",
                  prize: "",
                  prizeType: null,
                  totalAmount: null,
                },
              ],
            },
          ],
        },
        {
          stageName: "第2次复购",
          orderTimeConfig: {
            timeType: 1,
            joinDays: null,
            startTime: "",
            endTime: "",
          },
          orderRuleConfig: {
            orderPaymentType: 1,
            filterType: 0,
            skuIdList: [],
            statisticType: 0, // 0-按下单金额 1-自定义计量单位
            venderIds: [],
            sellerSkuList: [],
            multiShopGoods: [],
            filterSkuType: 0,
          },
          prizeConfig: {
            sendType: true,
            sendType: 0,
            delayDays: null,
            delayDays2: null,
          },
          stepPrizeList: [
            {
              orderAmtLimit: null,
              goodsList: [
                {
                  assetsId: "",
                  title: "",
                  logo: "",
                  prize: "",
                  prizeType: null,
                  totalAmount: null,
                },
              ],
            },
            {
              orderAmtLimit: null,
              goodsList: [
                {
                  assetsId: "",
                  title: "",
                  logo: "",
                  prize: "",
                  prizeType: null,
                  totalAmount: null,
                },
              ],
            },
          ],
        },
      ], //复购阶段配置列表
      isShowSpecified: false,
      specifiedProduct: [],
      trialProduct: [],
      isShowPrize: false,
      echoDate: {},
      prizeIndex: 0,
      currentIndex: 0,
      orderStatus: 0, //订单状态
      isShowSpecify: false,
      isShowToken: false,
      priceObj: {},
      // 试用商品
      isShowTrial: false,
      isShowExclusive: false,
      promotionId: "",
      // 专享价商品
      promotionList: [
        {
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: null,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
        },
      ],
      designatedSku: [],
      objExtraTip: "注：选择指定身份时，下方活动场景将不支持选择“会员生命周期”",
      itemArr: [],
      saveLoading: false,
      showSelectProduct: false,
      JingdouCount: {
        prizeCount: 0,
      },
      typeDefault: {
        grantType: 5, // 发放类型  传对应的id值
        display: 1, // 是否公开  传对应的id值
        type: 0, // 不禁用  传对应的id值
        noDisabled: [5], // 不禁用  传对应的id值  可不传（全部可选）
      },
      toAddItem: null,
      isShowAddNum: false,
      loading: false,
      templateObj: {},
      currrentRgb: "#191919",
      currrentRgb2: "#ffffff",
      currrentRgb3: "#ffffff",
      currrentRgb4: "#ffffff",
      currrentRgb5: "#ffffff",
      currrentRgb6: "#191919",
      currrentRgb7: "#ffffff",
      customerPaperwork: {
        title: "会员成长计划",
        desc: "首购加复购，好礼享不停",
        titleColor: "#191919",
        trialModelUrl: "",
        memberModelUrl: "",
        memberWordColor: "",
        memberBtnUrl: "",
        memberBtnWordColor: "",
        prizeModelUrl: "",
        modelWordColor: "",
        stepTabUrl: "",
        progressLeftColor: "",
        progressMiddleColor: "",
        progressRightColor: "",
      },
      actMember: "1",
      peopleSelected: [],
      templateId: "",
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      giftList: [],
      itemListFor: [], //商品弹框选择商品数据
      joinBlackList: false,
      checked: false,
      localStepNum: this.stepNum, // 将外部传入的步骤赋值到本地，避免直接更改props
      ruleForm: {
        startTime: "",
        endTime: "",
        condFollow: false,
        ruleDescription: "",
        partner: ["-1"],
        allowLevel: "-1",
        activityName: "",
        openCardFollow: 0,
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "",
        // 购物条件 - 累计完成订单笔数
        orderCompleteLimitCount: "", // 最小订单笔数
        orderCompleteMaxCount: "", // 最大订单笔数
        // 购物条件 - 累计完成订单金额
        orderCompleteLimitPayment: "", // 最小订单金额
        orderCompleteMaxPayment: "", // 最大订单金额
        // 购物条件 - 最后一次订单完成时间
        lastOrderCompleteTimeType: 0, // 时间类型: 0-不限, 1-距当前天数范围, 2-指定时间段
        lastOrderCompleteStartDay: "", // 距当前开始天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteEndDay: "", // 距当前结束天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteStartTime: "", // 指定开始时间 (当 lastOrderCompleteTimeType='2' 时)
        lastOrderCompleteEndTime: "", // 指定结束时间 (当 lastOrderCompleteTimeType='2' 时)
        joinType: 1, //参与方式
        joinStartTime: "", // 报名开始时间
        joinEndTime: "", // 报名结束时间
        applyLimitNum: "", // 报名人数限制
        isValidBlackList: 0,
      },
      ruleDTO: {
        customerPaperwork: "",
        cusTemplateJSON: "",
        plusObject: 0,
        goShopSetting: 0,
        goShopAppId: "",
        goShopUrl: "",
        // 分享设置
        shareTitle: "",
        shareIntroduce: "",
        sharePic: "",
        openCardStartTime: "",
        openCardEndTime: "",
        activityScene: 1,
      },
      firstStageConfig: {
        stageName: "会员首购",
        enableExclusivePrice: true,
        enableFirstPurchase: false,
        exclusivePriceConfig: {
          joinDays: "",
          designatedSku: {},
        },
        purchaseOrderConfig: {},
      },
      purchaseOrderConfig: {
        orderTimeConfig: {
          timeType: 1,
          joinDays: "",
          startTime: null,
          endTime: null,
          // 订单获取条件：仅timeType=2时生效，null/0-下单时间需在入会时间之后，1-入会和下单时间均在指定下单时间内即可满足
          orderGetCondition: null,
        },
        orderRuleConfig: {
          orderPaymentType: 1,
          filterType: 0,
          statisticType: 0, // 0-按下单金额 1-自定义计量单位
          skuIdList: [],
          venderIds: [],
          sellerSkuList: [],
          filterSkuType: 0,
          mergeOrder: false,
        },
        prizeConfig: {
          enabled: false,
          sendType: 0,
          delayDays: null,
          delayDays2: null,
        },
      },
      specifyOrExcludeGoods: [],
      prizeList: [
        {
          orderAmtLimit: null,
          specifiedProduct: [],
          goodsList: [
            {
              assetsId: "",
              title: "",
              logo: "",
              prize: "",
              prizeType: null,
              totalAmount: null,
            },
          ],
          venderIds: [],
          sellerSkuList: [],
        },
        {
          orderAmtLimit: null,
          specifiedProduct: [],
          goodsList: [
            {
              assetsId: "",
              title: "",
              logo: "",
              prize: "",
              prizeType: null,
              totalAmount: null,
            },
          ],
          venderIds: [],
          sellerSkuList: [],
        },
      ], //奖品设置
      sharePic: "",
      activityStartTime: null,
      activityEndTime: null,
      templateJson: {
        templateUItype: "",
      },

      levelList: [],
      isDraft: false,
      //下单时间限制
      orderPickerOptionsStart: {
        disabledDate: (time) => {
          if (this.purchaseOrderConfig.orderTimeConfig.endTime) {
            return (
              time.getTime() >
              new Date(
                this.purchaseOrderConfig.orderTimeConfig.endTime
              ).getTime()
            );
          }
          return false;
        },
      },
      orderPickerOptionsEnd: {
        disabledDate: (time) => {
          if (
            this.purchaseOrderConfig.orderTimeConfig.startTime ||
            this.ruleForm.endTime
          ) {
            return (
              time.getTime() <
                new Date(
                  this.purchaseOrderConfig.orderTimeConfig.startTime
                ).getTime() ||
              time.getTime() > new Date(this.ruleForm.endTime).getTime()
            );
          }
          return false;
        },
      },
      //下单时间限制
      stageOrderPickerOptionsStart: {
        disabledDate: (time) => {
          let row = this.repurchaseStages[this.rankValue];
          if (row.orderTimeConfig.endTime) {
            return (
              time.getTime() > new Date(row.orderTimeConfig.endTime).getTime()
            );
          }
          return false;
        },
      },
      stageOrderPickerOptionsEnd: {
        disabledDate: (time) => {
          let row = this.repurchaseStages[this.rankValue];
          if (row.orderTimeConfig.startTime || this.ruleForm.endTime) {
            return (
              time.getTime() <
                new Date(row.orderTimeConfig.startTime).getTime() ||
              time.getTime() > new Date(this.ruleForm.endTime).getTime()
            );
          }
          return false;
        },
      },
      pickerOptionApplyStart: {
        disabledDate: (time) => {
          if (this.ruleForm.endTime && this.ruleForm.startTime) {
            return (
              time.getTime() > new Date(this.ruleForm.endTime).getTime() ||
              time.getTime() <
                new Date(this.ruleForm.startTime).getTime() -
                  24 * 60 * 60 * 1000
            );
          } else {
            return false;
          }
        },
      },
      pickerOptionApplyEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.endTime && this.ruleForm.startTime) {
            return (
              time.getTime() > new Date(this.ruleForm.endTime).getTime() ||
              time.getTime() <
                new Date(this.ruleForm.startTime).getTime() -
                  24 * 60 * 60 * 1000 ||
              time.getTime() <
                new Date(this.ruleForm.joinStartTime).getTime() -
                  24 * 60 * 60 * 1000
            );
          } else {
            return false;
          }
        },
      },
    };
  },
  computed: {
    // 自定义单位名称
    purchaseOrderUnitName() {
      if (
        this.unitList.length > 0 &&
        this.purchaseOrderConfig.orderRuleConfig.statisticType != 0
      ) {
        const item = this.unitList.find(
          (v) => v.id == this.purchaseOrderConfig.orderRuleConfig.statisticType
        );
        if (item) {
          return item.name;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    venderId() {
      return this.$store.getters.loginUserInfo.venderId;
    },
    isVenderType() {
      return this.orderMultiShopGoods.some((item) => item.venderType);
    },
    isPop() {
      return this.orderMultiShopGoods.every((item) => !item.venderType);
    },
    isReVenderType() {
      return (row) => {
        return row.multiShopGoods.some((item) => item.venderType);
      };
    },
  },
  created() {
    this.sharePic = this.getDefaultSharePic(68);
    this.ruleDTO.sharePic = this.sharePic;
    this.ruleDTO.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`;
    this.ruleDTO.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`;
    this.getmeasureUnitPage();
  },
  mounted() {
    this.initData();
    this.getLevel();
    this.getDetail();
    this.buriedPoint(1, "会员成长计划", "互动管理", "互动活动");
  },

  methods: {
    viewMergeLogic() {
      window.open("https://www.yuque.com/yunduanxincrm/mrkpcq/mub1q6wafxefavp4?singleDoc#")
    },
    viewStatisticsLogic() {
      window.open("https://www.yuque.com/yunduanxincrm/mrkpcq/ribmlurbi01iznn8?singleDoc#")
    },
    filterTypeChange() {
      this.purchaseOrderConfig.orderRuleConfig.filterSkuType = 0;
    },
    changeShop(list) {
      if (list.length > 1) {
        this.purchaseOrderConfig.orderRuleConfig.statisticType = 0;
      }
    },
    changeShopStep(list, index) {
      if (list.length > 0) {
        this.repurchaseStages[index].orderRuleConfig.statisticType = 0;
      }
      // 根据店铺类型自动设置金额统计类型
      const multiShopGoods =
        this.repurchaseStages[index].orderRuleConfig.multiShopGoods || [];
      this.expoMultiShopGoods = multiShopGoods;
      const hasVender = multiShopGoods.some((item) => item.venderType);
      // const isPop = multiShopGoods.length > 0 && !hasVender;
      // if (!isPop) {
      //   // 包含自营或混合，设置为订单金额
      //   this.repurchaseStages[index].orderRuleConfig.orderPaymentType = 1;
      // } 
      // else {
      //   // 包含自营或混合，设置为订单金额
      //   this.repurchaseStages[index].orderRuleConfig.orderPaymentType = 1;
      // }
    },
    initData() {
      this.purchaseOrderConfig.orderRuleConfig.venderIds =
        this.purchaseOrderConfig.orderRuleConfig.venderIds &&
        this.purchaseOrderConfig.orderRuleConfig.venderIds.length > 0
          ? this.purchaseOrderConfig.orderRuleConfig.venderIds
          : [this.venderId];
      this.purchaseOrderConfig.orderRuleConfig.sellerSkuList =
        this.purchaseOrderConfig.orderRuleConfig.sellerSkuList &&
        this.purchaseOrderConfig.orderRuleConfig.sellerSkuList.length > 0
          ? this.purchaseOrderConfig.orderRuleConfig.sellerSkuList
          : [
              {
                venderId: this.venderId,
                skuIds: [],
                itemList: [],
              },
            ];
      this.repurchaseStages.forEach((item) => {
        item.orderRuleConfig.venderIds =
          item.orderRuleConfig.venderIds &&
          item.orderRuleConfig.venderIds.length > 0
            ? item.orderRuleConfig.venderIds
            : [this.venderId];
        item.orderRuleConfig.sellerSkuList =
          item.orderRuleConfig.sellerSkuList &&
          item.orderRuleConfig.sellerSkuList.length > 0
            ? item.orderRuleConfig.sellerSkuList
            : [
                {
                  venderId: this.venderId,
                  skuIds: [],
                  itemList: [],
                },
              ];
        item.orderRuleConfig.multiShopGoods = useValidateMultiShopGoods(this, [
          this.venderId,
        ]);
      });
      this.expoMultiShopGoods =
        this.repurchaseStages[0].orderRuleConfig.multiShopGoods;
      this.prizeList.forEach((item) => {
        item.venderIds =
          item.venderIds && item.venderIds.length > 0
            ? item.venderIds
            : [this.venderId];
        item.sellerSkuList =
          item.sellerSkuList && item.sellerSkuList.length > 0
            ? item.sellerSkuList
            : [
                {
                  venderId: this.venderId,
                  skuIds: [],
                  itemList: [],
                },
              ];
        item.multiShopGoods =
          item.venderIds.length > 0
            ? useValidateMultiShopGoods(this, item.venderIds)
            : useValidateMultiShopGoods(this, [this.venderId]);
      });
      // this.orderMultiShopGoods =
      //   this.purchaseOrderConfig.orderRuleConfig.venderIds &&
      //   this.purchaseOrderConfig.orderRuleConfig.venderIds.length > 0
      //     ? useValidateMultiShopGoods(
      //         this,
      //         this.purchaseOrderConfig.orderRuleConfig.venderIds
      //       )
      //     : useValidateMultiShopGoods(this, [this.venderId]);
      this.trialMultiShopGoods =
        this.purchaseOrderConfig.orderRuleConfig.venderIds &&
        this.purchaseOrderConfig.orderRuleConfig.venderIds.length > 0
          ? useValidateMultiShopGoods(
              this,
              this.purchaseOrderConfig.orderRuleConfig.venderIds
            )
          : useValidateMultiShopGoods(this, [this.venderId]);
    },
    changeParticipateType(type) {
      this.isSignLimitTime = false; // 报名限制
      this.ruleForm.joinStartTime = "";
      this.ruleForm.joinEndTime = "";
    },
    applyBlur(time, type) {
      if (type == "start") {
        if (!time.value) {
          this.$message.warning("请选择报名开始时间");
        }
      } else if (type == "end") {
        if (!time.value) {
          this.$message.warning("请选择报名结束时间");
        }
      }
    },
    applyTimeChange() {
      let applyStart = new Date(this.ruleForm.joinStartTime).valueOf();
      let applyEnd = new Date(this.ruleForm.joinEndTime).valueOf();
      if (!this.ruleForm.startTime && !this.ruleForm.endTime) {
        this.$message.warning("请先选择活动时间");
        this.ruleForm.joinStartTime = "";
        this.ruleForm.joinEndTime = "";
        return;
      }
      if (applyStart > applyEnd) {
        this.$message.warning("报名开始时间不可晚于结束时间");
        this.ruleForm.joinEndTime = "";
      }
    },
    changeRepurchaseStatisticType(val, row) {
      if (val != 0) {
        row.orderRuleConfig.filterType = 1;
      } else {
        row.orderRuleConfig.filterType = 0;
      }
      row.orderRuleConfig.skuIdList = [];
    },
    changePurchaseOrderStatisticType(val) {
      if (val != 0) {
        this.purchaseOrderConfig.orderRuleConfig.filterType = 1;
      } else {
        this.purchaseOrderConfig.orderRuleConfig.filterType = 0;
      }
      this.specifyOrExcludeGoods = [];
    },
    goToMeasureUnit() {
      let routeUrl = this.$router.resolve({
        path: "/interactiveMarketing/interactiveMeasure_Unit",
      });
      window.open(routeUrl.href, "_blank");
    },
    // 获取自定义单位
    getmeasureUnitPage() {
      let data = {
        venderId: this.venderId,
        size: 9999,
        current: 1,
      };
      measureUnitPage(data).then((res) => {
        if (res.code == 1) {
          const list = res.data.records || [];
          this.unitList = list.filter((v) => v.status == 1);
        }
      });
    },
    handlePrizeConfigChange(val) {
      if (val == 1) {
        this.purchaseOrderConfig.prizeConfig.sendType = 0;
        this.purchaseOrderConfig.prizeConfig.delayDays = "";
        this.purchaseOrderConfig.prizeConfig.delayDays2 = "";
        this.prizeList = [
          {
            orderAmtLimit: null,
            specifiedProduct: [],
            goodsList: [
              {
                assetsId: "",
                title: "",
                logo: "",
                prize: "",
                prizeType: null,
                totalAmount: null,
              },
            ],
            venderIds: [],
            sellerSkuList: [],
            multiShopGoods: [],
          },
          {
            orderAmtLimit: null,
            specifiedProduct: [],
            goodsList: [
              {
                assetsId: "",
                title: "",
                logo: "",
                prize: "",
                prizeType: null,
                totalAmount: null,
              },
            ],
            venderIds: [],
            sellerSkuList: [],
            multiShopGoods: [],
          },
        ];
        this.initData();
      }
    },
    changeExclusivePrice(val) {
      if (!val) {
        this.firstStageConfig.exclusivePriceConfig.joinDays = "";
        this.promotionList = [
          {
            assetsId: null, // 资产项id(计划id优惠卷id商品id)
            prizeType: null,
            price: null,
            logo: null,
            title: "",
            totalAmount: null,
          },
        ];
        this.designatedSku = [];
      }
    },
    changeFirstPurchase(val) {
      if (!val) {
        this.purchaseOrderConfig.orderTimeConfig.timeType = 1;
        this.purchaseOrderConfig.orderTimeConfig.joinDays = "";
        this.purchaseOrderConfig.orderTimeConfig.startTime = "";
        this.purchaseOrderConfig.orderTimeConfig.endTime = "";
        // 取消首购勾选，重置订单获取条件
        this.purchaseOrderConfig.orderTimeConfig.orderGetCondition = null;
        this.purchaseOrderConfig.orderRuleConfig.orderPaymentType = 1
        this.purchaseOrderConfig.orderRuleConfig.filterType = 0;
        this.specifyOrExcludeGoods = [];
        this.purchaseOrderConfig.prizeConfig.enabled = false;
        this.purchaseOrderConfig.prizeConfig.sendType = 0;
        this.purchaseOrderConfig.prizeConfig.delayDays = "";
        this.purchaseOrderConfig.prizeConfig.delayDays2 = "";
        this.prizeList = [
          {
            orderAmtLimit: null,
            specifiedProduct: [],
            goodsList: [
              {
                assetsId: "",
                title: "",
                logo: "",
                prize: "",
                prizeType: null,
                totalAmount: null,
              },
            ],
            venderIds: [],
            sellerSkuList: [],
            multiShopGoods: [],
          },
          {
            orderAmtLimit: null,
            specifiedProduct: [],
            goodsList: [
              {
                assetsId: "",
                title: "",
                logo: "",
                prize: "",
                prizeType: null,
                totalAmount: null,
              },
            ],
            venderIds: [],
            sellerSkuList: [],
            multiShopGoods: [],
          },
        ];
      } else {
        this.orderMultiShopGoods =
        this.purchaseOrderConfig.orderRuleConfig.venderIds &&
        this.purchaseOrderConfig.orderRuleConfig.venderIds.length > 0
          ? useValidateMultiShopGoods(
              this,
              this.purchaseOrderConfig.orderRuleConfig.venderIds
            )
          : useValidateMultiShopGoods(this, [this.venderId]);
      }
      this.initData();
    },
    changeOrderTime(val, item) {
      if (val == 2) {
        item.joinDays = "";
      } else {
        item.startTime = "";
        item.endTime = "";
      }
    },
    changeTimeType(val) {
      if (val == 2) {
        this.purchaseOrderConfig.orderTimeConfig.joinDays = "";
        // 切换为指定时间，默认选中「下单时间需在入会时间后」
        if (this.purchaseOrderConfig.orderTimeConfig.orderGetCondition == null) {
          this.purchaseOrderConfig.orderTimeConfig.orderGetCondition = 0;
        }
      } else {
        this.purchaseOrderConfig.orderTimeConfig.startTime = "";
        this.purchaseOrderConfig.orderTimeConfig.endTime = "";
        // 切换为入会后，不需要订单获取条件，重置为null
        this.purchaseOrderConfig.orderTimeConfig.orderGetCondition = null;
      }
    },
    handleSendTypeChange(val) {
      if (val == 0) {
        this.purchaseOrderConfig.prizeConfig.delayDays = null;
        this.purchaseOrderConfig.prizeConfig.delayDays2 = null;
      } else if (val != 1) {
        this.purchaseOrderConfig.prizeConfig.delayDays = null;
      } else if (val != 2) {
        this.purchaseOrderConfig.prizeConfig.delayDays2 = null;
      }
    },
    addRepurchaseStock(scope, index, it) {
      this.toAddItem = {
        ...scope.row,
        num: scope.row.totalAmount,
      };
      this.currentPrizeIndex = it;
      this.stockIndex = index;
      this.isShowAddNum = true;
      this.stockPrizeIndex = scope.$index;
    },
    addStock(scope, index) {
      this.toAddItem = {
        ...scope.row,
        num: scope.row.totalAmount,
      };
      this.stockIndex = index;
      this.isShowAddNum = true;
      this.stockPrizeIndex = scope.$index;
    },
    changeStepSendType(val, item) {
      if (val == 0) {
        item.delayDays = null;
        item.delayDays2 = null;
      } else if (val != 1) {
        item.delayDays = null;
      } else if (val != 2) {
        item.delayDays2 = null;
      }
    },
    changeFilterType(row) {
      row.skuIdList = [];
      this.stepspecifyOrExcludeGoods = [];
    },
    clearStageTime(item) {
      item.startTime = "";
      item.endTime = "";
    },
    clearTime() {
      this.purchaseOrderConfig.orderTimeConfig.startTime = "";
      this.purchaseOrderConfig.orderTimeConfig.endTime = "";
    },
    clearApplyTime() {
      this.ruleForm.joinStartTime = "";
      this.ruleForm.joinEndTime = "";
    },
    stageNameSet() {
      if (this.ruleDTO.activityScene == 1) {
        this.repurchaseStages.forEach((item, index) => {
          item.stageName = `第${index + 1}次复购`;
        });
      } else {
        this.repurchaseStages.forEach((item, index) => {
          if (index == 0) {
            item.stageName = `首购礼`;
          } else {
            item.stageName = `第${index}次复购`;
          }
        });
      }
    },
    addRePurchaseStage() {
      if (this.repurchaseStages.length >= 10) {
        this.$message.warning("最多只能配置10个复购阶段");
        return;
      }
      this.repurchaseStages.push({
        stageName: "",
        orderTimeConfig: {
          timeType: 1,
          joinDays: null,
          startTime: "",
          endTime: "",
        },
        orderRuleConfig: {
          orderPaymentType: 1,
          filterType: 0,
          skuIdList: [],
          statisticType: 0,
          venderIds: [],
          multiShopGoods: [],
          sellerSkuList: [],
          filterSkuType: 0,
          mergeOrder: false,
        },
        prizeConfig: {
          sendType: true,
          sendType: 0,
          delayDays: null,
          delayDays2: null,
        },
        stepPrizeList: [
          {
            orderAmtLimit: null,
            goodsList: [
              {
                assetsId: "",
                title: "",
                logo: "",
                prize: "",
                prizeType: null,
                totalAmount: null,
              },
            ],
          },
          {
            orderAmtLimit: null,
            goodsList: [
              {
                assetsId: "",
                title: "",
                logo: "",
                prize: "",
                prizeType: null,
                totalAmount: null,
              },
            ],
          },
        ],
      });
      this.repurchaseStages.forEach((item) => {
        item.orderRuleConfig.venderIds =
          item.orderRuleConfig.venderIds &&
          item.orderRuleConfig.venderIds.length > 0
            ? item.orderRuleConfig.venderIds
            : [this.venderId];
        item.orderRuleConfig.sellerSkuList =
          item.orderRuleConfig.sellerSkuList &&
          item.orderRuleConfig.sellerSkuList.length > 0
            ? item.orderRuleConfig.sellerSkuList
            : [
                {
                  venderId: this.venderId,
                  skuIds: [],
                  itemList: [],
                },
              ];
        item.orderRuleConfig.multiShopGoods = useValidateMultiShopGoods(this, [
          this.venderId,
        ]);
      });
      this.stageNameSet();
    },
    removeRank(index) {
      if (this.repurchaseStages.length <= 1) {
        this.$message.warning("最少需配置一个复购阶段");
        return;
      }
      if (this.activityData.isStart || this.backgroundOpacity) {
        return;
      }
      this.repurchaseStages.splice(index, 1);
      this.stageNameSet();
      if (index == this.rankValue) {
        this.rankValue = index == 0 ? "0" : index - 1 + "";
      } else if (index < this.rankValue) {
        this.rankValue = this.rankValue - 1 + "";
      }
    },
    deleteStepPrize(index) {
      this.prizeList.splice(index, 1);
    },
    deleteRepurchasePrize(row, index) {
      row.stepPrizeList.splice(index, 1);
    },
    selectSpecifiedProduct(index) {
      this.currentIndex = index;
      this.specifiedProduct = this.prizeList[index].specifiedProduct;
      this.isShowSpecified = true;
    },
    deleteSpecifiedPrize(specifiedProduct, index) {
      specifiedProduct.splice(index, 1);
    },
    deletePrize(index, scopeItem) {
      scopeItem.itemList.splice(index, 1);
      scopeItem.skuIds.splice(index, 1);
    },
    addPrizeSetting() {
      if (this.prizeList.length >= 5) {
        this.$message({
          message: "最多只能添加5个奖品设置",
          type: "warning",
        });
        return;
      }
      this.prizeList.push({
        orderAmtLimit: null,
        specifiedProduct: [],
        goodsList: [
          {
            assetsId: "",
            title: "",
            logo: "",
            prize: "",
            prizeType: null,
            totalAmount: null,
          },
        ],
        venderIds: [],
        sellerSkuList: [],
        multiShopGoods: [],
      });
      this.initData();
    },
    addStepPrizeSetting(row) {
      if (row.stepPrizeList.length >= 5) {
        this.$message({
          message: "最多只能添加5个奖品设置",
          type: "warning",
        });
        return;
      }
      row.stepPrizeList.push({
        orderAmtLimit: null,
        goodsList: [
          {
            assetsId: "",
            title: "",
            logo: "",
            prize: "",
            prizeType: null,
            totalAmount: null,
          },
        ],
      });
    },
    selectGoodFn(goodsList, index, scope) {
      this.currentIndex = index;
      this.prizeIndex = scope.$index;
      this.JingdouCount.prizeCount = scope.row.totalAmount;
      this.echoDate = scope.row;
      this.itemArr = goodsList;
      this.isShowPrize = true;
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
      });
    },
    selectRepurchaseGoodFn(goodsList, it, scope) {
      this.stepPrizeIndex = it;
      this.JingdouCount.prizeCount = scope.row.totalAmount;
      this.echoDate = scope.row;
      this.itemArr = goodsList;
      this.isShowStepPrize = true;
      this.$nextTick(() => {
        this.$refs.selectStepProduct.openDialog();
      });
    },
    openGoods() {
      this.isShowSpecify = true;
    },
    openStepSpecify(list, item) {
      this.stepspecifyItem = item;
      this.stepspecifyOrExcludeGoods = list;
      if (item.orderRuleConfig.statisticType == 0) {
        this.isShowStepSpecify = true;
      } else {
        this.isShowSelectUnitGoods2 = true;
      }
    },
    getSpecifyOrExcludeGoods(data) {
      if (data && data.length > 0) {
        this.specifyOrExcludeGoods = data;
        this.purchaseOrderConfig.orderRuleConfig.skuIdList = data.map(
          (item) => item.skuId
        );
      }
      this.isShowSpecify = false;
      this.isShowSelectUnitGoods = false;
    },
    getStepSpecifyOrExcludeGoods(data) {
      if (data && data.length > 0) {
        this.stepspecifyOrExcludeGoods = [];
        this.repurchaseStages[this.rankValue].orderRuleConfig.skuIdList = [];
        data.forEach((item) => {
          let obj = {
            skuId: "",
            title: "",
            logo: "",
            price: "",
          };
          obj.skuId = item.skuId;
          obj.title = item.wareTitle || item.title;
          obj.logo = item.logo;
          obj.price = item.jdPrice;
          this.stepspecifyOrExcludeGoods.push(obj);
          this.repurchaseStages[this.rankValue].orderRuleConfig.skuIdList.push(
            obj
          );
        });
      }
      this.isShowStepSpecify = false;
      this.isShowSelectUnitGoods2 = false;
    },
    getTrialProduct(data) {
      if (data.length > 0) {
        this.trialProduct = [];
        data.forEach((item) => {
          let obj = {
            skuId: "",
            skuName: "",
            logo: "",
            price: "",
          };
          obj.skuId = item.skuId;
          obj.title = item.wareTitle || item.title;
          obj.logo = item.logo;
          obj.price = item.jdPrice;
          this.trialProduct.push(obj);
        });
      }
      this.isShowTrial = false;
    },
    getSpecifiedProduct(data) {
      if (data.length > 0) {
        let arr = [];
        data.forEach((item) => {
          let obj = {
            skuId: "",
            skuName: "",
            logo: "",
            price: "",
          };
          obj.skuId = item.skuId;
          obj.title = item.wareTitle || item.title;
          obj.logo = item.logo;
          obj.price = item.jdPrice;
          arr.push(obj);
        });
        this.$set(this.prizeList[this.currentIndex], "specifiedProduct", arr);
      }
      this.isShowSpecified = false;
    },
    //判断尺寸方法 默认200*200
    imgchecked(file, width = 200, height = 200) {
      let _this = this;
      return new Promise((resolve, reject) => {
        let type = file.name
          .substring(file.name.lastIndexOf("."))
          .toLowerCase();
        let sorts = [".png", ".jpg"];
        if (sorts.indexOf(type) < 0) {
          reject();
          this.$message.info("所选图片格式不符，请重新选择");
        } else {
          let image = new Image();
          let _URL = window.URL || window.webkitURL;
          image.onload = function () {
            const valid = image.width == width && image.height == height;
            file.isFlag = valid;
            if (valid) {
              resolve(true);
            } else {
              _this.$message.info("图片尺寸不符合要求，请重新上传");
              reject();
            }
          };
          image.src = _URL.createObjectURL(file);
        }
      });
    },
    async beforeUploadPrize(file) {
      const status = await this.imgchecked(file, 200, 200);
      if (!status) {
        return false;
      }
    },
    uploadLogo(val) {
      this.designatedSku[0].logo = val.data;
    },
    // 确认专享价
    confirmExclusiveOrToken(val) {
      const currentTotalAmount =
        (this.promotionList[0] && this.promotionList[0].totalAmount) || "";
      this.promotionList = [];
      this.designatedSku = [];
      if (this.venderType) {
        this.priceObj = {
          ...val.detailList[0].promoSkuList[0],
          id: val.tokenId,
        };
      } else {
        this.priceObj = {
          ...val.skuList[0],
          id: val.id,
        };
      }
      this.promotionList.push({
        assetsId: this.priceObj.id,
        prizeType: 12,
        price: val.minPayPrice,
        title: val.name,
        totalAmount: currentTotalAmount,
        logo: "https://cdn-image.yucrm.cn/96a42448b954472ebdc825c4d4af7268.png",
        prizeObjectType: 0,
        id: this.activityData.isStart ? this.currentId : null,
      });
      this.designatedSku.push({
        planId: this.priceObj.id,
        skuId: this.priceObj.skuId,
        skuName: this.priceObj.skuName,
        logo: this.priceObj.logo,
        jdPrice: this.priceObj.jdPrice,
        exclusivePrice: this.venderType
          ? this.activityData.isStart
            ? this.designatedSkuCopy[0].exclusivePrice
            : ""
          : this.priceObj.payPrice,
      });
      this.isShowExclusive = false;
      this.isShowToken = false;
    },
    selectPromotion(row) {
      this.currentId = row.id;
      if (this.venderType) {
        this.isShowToken = true;
      } else {
        this.isShowExclusive = true;
      }

      if (row.assetsId) {
        this.promotionId = row.assetsId;
      }
    },
    removePromotion() {
      this.promotionList = [
        {
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: null,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
        },
      ];
      this.designatedSku = [];
    },
    getMemberFn(val) {
      if (val == 2) {
        this.ruleDTO.activityScene = 2;
        this.changeScene(2);
      }
    },
    changeScene(val) {
      if (val == 1) {
        this.firstStageConfig.stageName = "会员首购";
        this.trialProduct = [];
        this.repurchaseStages.forEach((item, index) => {
          item.stageName = `第${index + 1}次复购`;
        });
        this.firstStageConfig.enableExclusivePrice = true;
        this.purchaseOrderConfig.orderTimeConfig.timeType = 1;
        this.purchaseOrderConfig.orderRuleConfig.filterType = 0;
      } else {
        this.firstStageConfig.enableExclusivePrice = false;
        this.firstStageConfig.enableFirstPurchase = false;
        this.firstStageConfig.joinDays = null;
        this.promotionList = [
          {
            assetsId: null, // 资产项id(计划id优惠卷id商品id)
            prizeType: null,
            price: null,
            logo: null,
            title: "",
            totalAmount: null,
          },
        ];
        this.designatedSku = [];
        this.purchaseOrderConfig.orderTimeConfig.timeType = 2;
        this.purchaseOrderConfig.orderTimeConfig.joinDays = null;
        this.purchaseOrderConfig.orderRuleConfig.filterType = 0;
        this.specifyOrExcludeGoods = [];
        this.firstStageConfig.stageName = "试用尝鲜";
        this.repurchaseStages.forEach((item, index) => {
          if (index == 0) {
            item.stageName = `首购礼`;
          } else {
            item.stageName = `第${index}次复购`;
          }
        });
      }

      this.purchaseOrderConfig.orderTimeConfig.startTime = "";
      this.purchaseOrderConfig.orderTimeConfig.endTime = "";
      // 重置订单获取条件
      this.purchaseOrderConfig.orderTimeConfig.orderGetCondition = null;
      this.purchaseOrderConfig.prizeConfig.enabled = false;
      this.purchaseOrderConfig.prizeConfig.sendType = 0;
      this.purchaseOrderConfig.prizeConfig.delayDays = null;
      this.purchaseOrderConfig.prizeConfig.delayDays2 = null;
      this.purchaseOrderConfig.orderRuleConfig.orderPaymentType = 1;
      this.prizeList = [
        {
          orderAmtLimit: null,
          specifiedProduct: [],
          goodsList: [
            {
              assetsId: "",
              title: "",
              logo: "",
              prize: "",
              prizeType: null,
              totalAmount: null,
            },
          ],
          venderIds: [],
          sellerSkuList: [],
          multiShopGoods: [],
        },
        {
          orderAmtLimit: null,
          specifiedProduct: [],
          goodsList: [
            {
              assetsId: "",
              title: "",
              logo: "",
              prize: "",
              prizeType: null,
              totalAmount: null,
            },
          ],
          venderIds: [],
          sellerSkuList: [],
          multiShopGoods: [],
        },
      ];
      this.initData();
    },
    // 背景图上传校验
    async beforeUploadUI(file, type) {
      let sizeype = {
        1: {
          width: 702,
          height: 523,
        },
        2: {
          width: 146,
          height: 52,
        },
        3: {
          width: 702,
          height: 863,
        },
        4: {
          width: 708,
          height: 141,
        },
        5: {
          width: 702,
          height: 643,
        },
      };
      const status = await this.imgchecked(
        file,
        sizeype[type].width,
        sizeype[type].height
      );
      if (!status) {
        return false;
      }
    },
    // 背景图上传图片
    handleUploadUI(res, type) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        if (type == 1) {
          this.customerPaperwork.memberModelUrl = res.data;
        } else if (type == 2) {
          this.customerPaperwork.memberBtnUrl = res.data;
        } else if (type == 3) {
          this.customerPaperwork.prizeModelUrl = res.data;
        } else if (type == 4) {
          this.customerPaperwork.stepTabUrl = res.data;
        } else if (type == 5) {
          this.customerPaperwork.trialModelUrl = res.data;
        }
        this.$message.success("背景图上传成功");
      }
    },
    getPrizeCommon(data, prizeType) {
      //处理奖品返回字段公共部分
      let prizeObj = {
        price: "",
        assetsId: "",
        logo: "",
        prizeType: "",
        title: "",
      };
      if (prizeType == 1) {
        prizeObj.couponType = data.couponType;
      }
      if (data.giftType) {
        prizeObj.giftType = Number(data.giftType);
      }
      prizeObj.price = Number(data.discount);

      prizeObj.assetsId = data.couponId ? Number(data.couponId) : data.skuId;
      prizeObj.logo = data.logo || this.defaultLogo;
      prizeObj.prizeType = prizeType;

      if (prizeType == 4) {
        prizeObj.title = data.discount + "店铺积分";
      } else {
        prizeObj.title = data.name;
      }

      if (data.singleAmount) {
        prizeObj.singleAmount = data.singleAmount;
      }
      if (prizeType == 2) {
        prizeObj.quantityTotal = data.quantityTotal;
        prizeObj.totalAmount = data.totalAmount;
        prizeObj.cycleType = data.cycleType;
        prizeObj.bindPlanList = data.bindPlanList;
      }
      if (prizeType == 3) {
        if (!data.isGoodManage) {
          prizeObj.skuId = data.skuId;
          delete prizeObj.isGoodManage;
        } else {
          prizeObj.isGoodManage = data.isGoodManage;
        }
        prizeObj.predictSendTime = data.predictSendTime;
        prizeObj.isFollowActivityEndTime = data.isFollowActivityEndTime
          ? data.isFollowActivityEndTime
          : 0;
        prizeObj.addressFillEndTime = data.addressFillEndTime;
        prizeObj.shouldCollectExtraData = data.shouldCollectExtraData;
        prizeObj.extraQuestion = data.extraQuestion;
        prizeObj.addressFillLimit = data.addressFillLimit;
        prizeObj.commitAddressLimit = data.commitAddressLimit;
      }
      // 实物随单发
      if (prizeType == 14 || prizeType == 1) {
        this.getPhysicalShipped(prizeObj, prizeType, data);
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if ([2, 5, 6, 7, 8, 10].includes(Number(prizeType))) {
        prizeObj.budgetRemain = data.budgetRemain;
      }
      if (prizeType == 3 && data.isGoodManage) {
        prizeObj.budgetRemain = data.budgetRemain;
      }
      return prizeObj;
    },
    getTheData(data, prizeType) {
      // 阶梯奖品
      this.$set(
        this.prizeList[this.currentIndex].goodsList,
        this.prizeIndex,
        this.getPrizeCommon(data, prizeType)
      );
      this.isShowPrize = false;
    },
    getStepTheData(data, prizeType) {
      // 阶梯奖品
      this.$set(
        this.repurchaseStages[this.rankValue].stepPrizeList[this.stepPrizeIndex]
          .goodsList,
        0,
        this.getPrizeCommon(data, prizeType)
      );
      this.isShowStepPrize = false;
    },
    confirmAdd(num) {
      if (this.currentPrizeIndex >= 0) {
        this.$set(
          this.repurchaseStages[this.stockIndex].stepPrizeList[
            this.currentPrizeIndex
          ].goodsList[0],
          "totalAmount",
          Number(num)
        );
      } else {
        this.$set(
          this.prizeList[this.stockIndex].goodsList[this.stockPrizeIndex],
          "totalAmount",
          Number(num)
        );
      }
      this.isShowAddNum = false;
    },
    // 京东计划数量计算
    prizeNum(row) {
      // 京豆计划已在其他函数判断，这里只计算 京东E卡、plus、爱奇艺、红包
      if ([5, 6, 7, 8, 10].includes(Number(row.prizeType))) {
        if (
          Number(row.totalAmount) &&
          Number(row.totalAmount) > row.budgetRemain
        ) {
          row.totalAmount = "";
          if (row.prizeType == 5)
            this.$message.error(
              "京东E卡总份额数量不能大于该京东E卡剩余预算额！"
            );
          if (row.prizeType == 6)
            this.$message.error(
              "爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！"
            );
          if (row.prizeType == 7)
            this.$message.error(
              "京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！"
            );
          if (row.prizeType == 8)
            this.$message.error(
              "现金红包总份额数量不能大于该现金红包剩余预算额！"
            );
          if (row.prizeType == 10)
            this.$message.error("礼品卡总份额数量不能大于该礼品卡剩余预算额！");
        }
      }
    },
    checkputn(e, row = {}) {
      if (
        row.quantityTotal &&
        row.price &&
        row.totalAmount &&
        row.prizeType == 2
      ) {
        let numTotal = this.$jingdouTotal({
          ...row,
          prizeCount: row.totalAmount,
        });
        if (!numTotal) {
          this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
        }
        return numTotal;
      } else {
        return row.totalAmount;
      }
    },

    initCustomizeData(row) {
      let configJson = row.configJson && JSON.parse(row.configJson);
      this.customerPaperwork.titleColor = row.rgb;
      this.customerPaperwork.memberWordColor = row.rgb2;
      this.customerPaperwork.memberBtnWordColor = row.rgb3;
      this.customerPaperwork.modelWordColor = configJson.rgb4;
      this.customerPaperwork.progressLeftColor = configJson.rgb5;
      this.customerPaperwork.progressMiddleColor = configJson.rgb6;
      this.customerPaperwork.progressRightColor = configJson.rgb7;
      this.currrentRgb = row.rgb;
      this.currrentRgb2 = row.rgb2;
      this.currrentRgb3 = row.rgb3;
      this.currrentRgb4 = configJson.rgb4;
      this.currrentRgb5 = configJson.rgb5;
      this.currrentRgb6 = configJson.rgb6;
      this.currrentRgb7 = configJson.rgb7;
    },
    selectTemplate(index, id, item) {
      this.templateObj = item;
      this.templateId = id;
      this.templateJson.templateUItype = index;
      this.initCustomizeData(item);
    },
    onShopSetChange(value) {
      this.ruleDTO.goShopAppId = "";
      this.ruleDTO.goShopUrl = "";
    },

    // 选择人群关闭
    selectPeopleSure(val) {
      this.peopleSelected = val.map((item) => item.id);
    },
    // 京东计划数量计算
    prizeNum(row) {
      // 京豆计划已在其他函数判断，这里只计算 京东E卡、plus、爱奇艺、红包
      if ([5, 6, 7, 8, 10].includes(Number(row.prizeType))) {
        if (
          Number(row.totalAmount) &&
          Number(row.totalAmount) > row.budgetRemain
        ) {
          row.totalAmount = "";
          if (row.prizeType == 5)
            this.$message.error(
              "京东E卡总份额数量不能大于该京东E卡剩余预算额！"
            );
          if (row.prizeType == 6)
            this.$message.error(
              "爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！"
            );
          if (row.prizeType == 7)
            this.$message.error(
              "京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！"
            );
          if (row.prizeType == 8)
            this.$message.error(
              "现金红包总份额数量不能大于该现金红包剩余预算额！"
            );
          if (row.prizeType == 10)
            this.$message.error("礼品卡总份额数量不能大于该礼品卡剩余预算额！");
        }
      }
    },
    // 活动进行中修改奖品数量
    beAdd(row) {
      if (this.activityData.isStart) {
        if (row.totalAmount < row.minNum && row.minNum) {
          row.totalAmount = row.minNum;
          this.$message.error("为避免客诉，奖品数量不能小于之前哦~");
        }
      }
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },

    // 模板类型
    async hdTaskTemplateGroup() {
      this.getPolite();
    },

    // 活动模板
    async getPolite() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: "",
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      this.giftList =
        data.records && data.records.length > 0
          ? data.records.map((item) => {
              return {
                ...item,
                days: item.activityStartTime
                  ? this.getDaysBetween(
                      item.activityStartTime,
                      item.activityEndTime
                    )
                  : "",
              };
            })
          : [];
      if (!this.templateId && this.giftList.length > 0) {
        this.templateObj = this.giftList[0];
        this.templateId = this.giftList[0].id;
        this.templateJson.templateUItype = 0;
        this.initCustomizeData(this.templateObj);
      } else if (this.templateId) {
        let arr = this.giftList.filter((item) => item.id == this.templateId);
        this.templateObj = arr[0];
        this.templateId = this.templateId;
        let configJson =
          this.templateObj.configJson &&
          JSON.parse(this.templateObj.configJson);
        this.currrentRgb = this.templateObj.rgb;
        this.currrentRgb2 = this.templateObj.rgb2;
        this.currrentRgb3 = this.templateObj.rgb3;
        this.currrentRgb4 = configJson.rgb4;
        this.currrentRgb5 = configJson.rgb5;
        this.currrentRgb6 = configJson.rgb6;
        this.currrentRgb7 = configJson.rgb7;
        this.customerPaperwork.titleColor = this.customerPaperwork.titleColor;
        this.customerPaperwork.memberWordColor =
          this.customerPaperwork.memberWordColor;
        this.customerPaperwork.memberBtnWordColor =
          this.customerPaperwork.memberBtnWordColor;
        this.customerPaperwork.modelWordColor =
          this.customerPaperwork.modelWordColor;
        this.customerPaperwork.progressLeftColor =
          this.customerPaperwork.progressLeftColor;
        this.customerPaperwork.progressMiddleColor =
          this.customerPaperwork.progressMiddleColor;
        this.customerPaperwork.progressRightColor =
          this.customerPaperwork.progressRightColor;
      }
      this.pageData.total = data.total * 1;
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
        })
        .catch((res) => {
          console.error(res);
        });
    },
    //生成规则
    generateRule() {
      let text6 = "",
        text7 = "复购阶段奖品：" + "\n",
        text8 =
          "奖品总量：所有奖品数量有限，先到先得，送完即止。同一用户在单个复购阶段仅可领取对应奖品一次。",
        text9 = `订单与收货：用户需在 每个阶段 按要求指定商品的下单，并在完成订单条件。\n2. 及时领奖：完成下单条件后，用户须在 活动时间结束前 回到活动页手动领取对应阶段的奖品，逾期未领取视为放弃。\n3.信息填写：如为实物奖品，用户需在领奖时或于活动结束前，在活动页完善收货地址,逾期视为放弃。\n4.身份维持：用户在整个活动链条中（从首次参与到完成最后一次复购领奖）必须始终保持（${this.$store.getters.loginUserInfo.shopTitle}）会员身份，若中途退出则失去所有未领取及后续的获奖资格。\n5.退款与取消：如用户对参与活动的任一商品订单进行退款，导致该阶段订单状态不满足活动条件，则对应阶段及后续阶段的获奖资格将被取消。\n6.排序规则：由于奖品数量有限，系统将根据用户达成各阶段条件的 确认收货时间先后 进行发奖。若最后一份奖品出现多名用户同时达成，将采取系统随机方式抽取。`,
        secondText = "\n二、【活动参与规则】",
        thirdText = "\n三、【活动奖品】",
        fourthText = "\n四、【如何获奖】",
        fifthText = "\n五、【注意事项】";
      const { firstText, precautions } = this.getCommonText(
        this.levelList,
        this.ruleForm,
        this.ruleDTO,
        this.actMember,
        false,
        true
      );
      //参与规则
      let arr = [];
      let text = "";
      if (this.ruleDTO.activityScene == 1) {
        if (
          this.firstStageConfig.enableExclusivePrice &&
          !this.firstStageConfig.enableFirstPurchase
        ) {
          text = `首购礼：仅限在入会后${this.firstStageConfig.exclusivePriceConfig.joinDays}天购买促销活动商品的用户参与；`;
          arr.push(text);
        } else if (
          this.firstStageConfig.enableFirstPurchase &&
          !this.firstStageConfig.enableExclusivePrice
        ) {
          if (this.purchaseOrderConfig.orderTimeConfig.timeType == 1) {
            text = `首购礼：仅限用户入会后${this.purchaseOrderConfig.orderTimeConfig.joinDays}天内下单的用户参与；`;
          } else {
            text = `仅限用户入会后，在指定时间${this.purchaseOrderConfig.orderTimeConfig.startTime}~${this.purchaseOrderConfig.orderTimeConfig.endTime}范围内下单的用户参与；`;
          }
          arr.push(text);
        } else {
          text = `首购礼：仅限在入会后${this.purchaseOrderConfig.orderTimeConfig.joinDays}天购买促销活动商品的用户参与；且用户入会后，在指定时间${this.purchaseOrderConfig.orderTimeConfig.startTime}~${this.purchaseOrderConfig.orderTimeConfig.endTime}范围内下单的用户参与；`;
          arr.push(text);
        }
      } else {
        text = `试用尝鲜：仅限在${this.purchaseOrderConfig.orderTimeConfig.startTime}~${this.purchaseOrderConfig.orderTimeConfig.endTime}时间范围内下单指定试用装的用户参与；`;
        arr.push(text);
      }
      let text2 = "";
      this.repurchaseStages.forEach((item, index) => {
        let unitName = "";
        if (item.orderRuleConfig.statisticType != 0) {
          unitName = this.unitList.find(
            (v) => v.id == item.orderRuleConfig.statisticType
          )
            ? this.unitList.find(
                (v) => v.id == item.orderRuleConfig.statisticType
              ).name
            : "";
        }
        if (this.ruleDTO.activityScene == 1) {
          text2 = `${item.stageName}：完成（${
            index == 0 ? "会员首购" : "第" + index + "次复购"
          }）阶段条件后${
            item.orderTimeConfig.timeType == 1
              ? item.orderTimeConfig.joinDays + "天"
              : "在指定时间" +
                item.orderTimeConfig.startTime +
                "~" +
                item.orderTimeConfig.endTime +
                "时间范围内"
          }内下单：购买${unitName ? unitName + "数" : "订单金额"}≥${
            item.stepPrizeList[0].orderAmtLimit
          }${unitName ? unitName : "元"}，${
            item.prizeConfig.sendType == 0
              ? "立即发放"
              : item.prizeConfig.sendType == 1
              ? "确认收货" + item.prizeConfig.delayDays + "天后发放"
              : "活动结束" + item.prizeConfig.delayDays2 + "天后发放"
          }奖品；`;
        } else {
          text2 = `${item.stageName}：完成（${
            index == 0
              ? "试用尝鲜"
              : index == 1
              ? "首购礼"
              : "第" + (index - 1) + "次复购"
          }）阶段条件后${
            item.orderTimeConfig.timeType == 1
              ? item.orderTimeConfig.joinDays + "天"
              : "在指定时间" +
                item.orderTimeConfig.startTime +
                "~" +
                item.orderTimeConfig.endTime +
                "时间范围内"
          }内下单：购买${unitName ? unitName + "数" : "订单金额"}≥${
            item.stepPrizeList[0].orderAmtLimit
          }${unitName ? unitName : "元"}，${
            item.prizeConfig.sendType == 0
              ? "立即发放"
              : item.prizeConfig.sendType == 1
              ? "确认收货" + item.prizeConfig.delayDays + "天后发放"
              : "活动结束" + item.prizeConfig.delayDays2 + "天后发放"
          }奖品；`;
        }

        arr.push(text2);
      });
      // 活动奖品
      if (
        this.ruleDTO.activityScene == 1 &&
        this.firstStageConfig.enableFirstPurchase &&
        this.purchaseOrderConfig.prizeConfig.enabled &&
        this.prizeList.length
      ) {
        let prizeArr = [];
        this.prizeList.forEach((item, index) => {
          let list = item.goodsList.filter((it) => it.prizeType != 0);
          if (list.length > 0) {
            prizeArr.push(...list.map((row) => row.title));
          }
        });
        if (prizeArr.length > 0) {
          text6 = `新会员：(${prizeArr.join("、")})，每人限领1次。`;
        }
      } else if (
        this.ruleDTO.activityScene == 2 &&
        this.purchaseOrderConfig.prizeConfig.enabled &&
        this.prizeList.length
      ) {
        let prizeArr = [];
        this.prizeList.forEach((item, index) => {
          let list = item.goodsList.filter((it) => it.prizeType != 0);
          if (list.length > 0) {
            prizeArr.push(...list.map((row) => row.title));
          }
        });
        if (prizeArr.length > 0) {
          text6 = `试用礼：(${prizeArr.join("、")})，每人限领1次。`;
        }
      }
      this.repurchaseStages.forEach((item, index) => {
        let repurchasePrize = [];
        item.stepPrizeList.forEach((row, index) => {
          let list = row.goodsList.filter((it) => it.prizeType != 0);
          if (list.length > 0) {
            repurchasePrize.push(...list.map((it) => it.title));
          }
        });
        if (repurchasePrize.length > 0) {
          if (index < this.repurchaseStages.length - 1) {
            text7 += `·${item.stageName}：(${repurchasePrize.join("、")})\n`;
          } else {
            text7 += `·${item.stageName}：(${repurchasePrize.join("、")})`;
          }
        }
      });

      let Arr1 = [
        firstText,
        [secondText, ...arr],
        [thirdText, text6, text7, text8],
        [fourthText, text9],
        [fifthText, precautions],
      ];
      let newText = "";

      Arr1.forEach((item, index) => {
        let newNum = 0;
        item.forEach((row, it) => {
          if (row.length > 0) {
            if (it != 0) {
              newText = newText + newNum + "." + row + "\n";
            } else {
              newText = newText + row + "\n";
            }
            newNum = newNum + 1;
          }
        });
      });
      this.ruleForm.ruleDescription = newText.trim();
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if (this.localStepNum == 0) this.$emit("returnBack");
      if (this.localStepNum == 1) this.localStepNum = 0;
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    //深拷贝
    deepClone(obj) {
      let theObj = JSON.stringify(obj),
        objClone = JSON.parse(theObj);
      return objClone;
    },

    // 下一步
    resetForm() {
      // 参与方式报名条件
      if (this.ruleForm.joinType == 0) {
        if (
          this.isSignLimitTime &&
          (!this.ruleForm.joinStartTime || !this.ruleForm.joinEndTime)
        ) {
          this.$message.warning("请选择报名时间");
          return;
        }
        if (
          (this.isSignLimitTime &&
            new Date(this.ruleForm.joinStartTime).getTime() <
              new Date(this.ruleForm.startTime).getTime()) ||
          new Date(this.ruleForm.joinEndTime).getTime() >
            new Date(this.ruleForm.endTime).getTime()
        ) {
          this.$message.warning("报名时间需在活动时间范围内");
          return;
        }
      }
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.startTime || !this.ruleForm.endTime) {
        this.$message.warning("请输入活动时间");
        return;
      }
      //活动对象限制
      if (
        this.actMember == 2 &&
        (!this.ruleForm.partner || this.ruleForm.partner.length == 0)
      ) {
        this.$message.warning("请选择活动对象");
        return;
      }
      if (this.actMember == 3 && !this.peopleSelected.length) {
        this.$message.warning("请选择指定人群");
        return;
      }

      // 1.14迭代 这里判断 指定入会时间
      if (this.actMember == "2") {
        if (
          this.ruleForm.firstOpenCardTimeType == 1 &&
          !this.ruleForm.openCardBeforeDay
        ) {
          return this.$message.warning("请完善首次入会时间");
        }
        if (
          this.ruleForm.firstOpenCardTimeType == 2 &&
          (!this.ruleDTO.openCardStartTime || !this.ruleDTO.openCardEndTime)
        ) {
          return this.$message.warning("请完善首次入会时间");
        }
        // 最后一次订单完成时间
        if (
          this.ruleForm.lastOrderCompleteTimeType == 1 &&
          !this.ruleForm.lastOrderCompleteEndDay &&
          !this.ruleForm.lastOrderCompleteStartDay
        ) {
          return this.$message.warning("最后一次订单完成时间");
        }

        if (
          this.ruleForm.lastOrderCompleteTimeType == 2 &&
          !this.ruleForm.lastOrderCompleteStartTime &&
          !this.ruleForm.lastOrderCompleteEndTime
        ) {
          return this.$message.warning("最后一次订单完成时间");
        }
      }
      if (
        this.ruleDTO.activityScene == 1 &&
        !this.firstStageConfig.enableExclusivePrice &&
        !this.firstStageConfig.enableFirstPurchase
      ) {
        return this.$message.warning("会员生命周期需至少配置一个首购场景");
      }
      if (
        this.ruleDTO.activityScene == 1 &&
        this.firstStageConfig.enableExclusivePrice &&
        !this.firstStageConfig.exclusivePriceConfig.joinDays
      ) {
        return this.$message.warning("请输入会员专属价用户入会时间");
      }
      //阶段校验
      if (!this.firstStageConfig.stageName) {
        return this.$message.warning("请输入阶段名称");
      }
      if (this.ruleDTO.activityScene == 1) {
        // 会员专属价下单校验
        if (this.firstStageConfig.enableExclusivePrice) {
          if (this.promotionList.some((item) => !item.prizeType)) {
            return this.$message.warning("请选择会员专属价");
          }
          if (this.designatedSku.some((item) => !item.exclusivePrice > 0)) {
            return this.$message.warning("请输入会员专属价");
          }
        }
        if (this.firstStageConfig.enableFirstPurchase) {
          if (
            this.purchaseOrderConfig.orderTimeConfig.timeType == 1 &&
            !this.purchaseOrderConfig.orderTimeConfig.joinDays
          ) {
            return this.$message.warning("请输入下单时间");
          }
          if (
            this.purchaseOrderConfig.orderTimeConfig.timeType == 2 &&
            (!this.purchaseOrderConfig.orderTimeConfig.startTime ||
              !this.purchaseOrderConfig.orderTimeConfig.endTime)
          ) {
            return this.$message.warning("请选择下单时间");
          }
          if (this.purchaseOrderConfig.orderRuleConfig.filterType != 0) {
            // if (
            //   this.purchaseOrderConfig.orderRuleConfig.filterType == 1 &&
            //   this.specifyOrExcludeGoods.length == 0
            // ) {
            //   return this.$message.warning("请选择指定商品");
            // }
            // if (
            //   this.purchaseOrderConfig.orderRuleConfig.filterType == 2 &&
            //   this.specifyOrExcludeGoods.length == 0
            // ) {
            //   return this.$message.warning("请选择排除商品");
            // }
            const obj =
              this.purchaseOrderConfig.orderRuleConfig.sellerSkuList.find(
                (item) => item.skuIds.length == 0
              );
            if (obj) {
              const types = {
                1: "指定",
                2: "排除",
              };
              const shop = this.orderMultiShopGoods.find(
                (item) => item.venderId == obj.venderId
              );
              return this.$message.warning(
                `请选择${shop.shopTitle}的${
                  types[this.purchaseOrderConfig.orderRuleConfig.filterType]
                }商品`
              );
            }
          }
          if (this.purchaseOrderConfig.prizeConfig.enabled) {
            if (
              this.purchaseOrderConfig.prizeConfig.sendType == 1 &&
              !this.purchaseOrderConfig.prizeConfig.delayDays
            ) {
              return this.$message.warning("请输入确认收货时间");
            }
            if (
              this.purchaseOrderConfig.prizeConfig.sendType == 2 &&
              !this.purchaseOrderConfig.prizeConfig.delayDays2
            ) {
              return this.$message.warning("请输入活动结束发放时间");
            }
            let orderAmt = false;
            let hasGoods = false;
            let current = 0;
            let current2 = 0;
            this.prizeList.some((item, index) => {
              if (!item.orderAmtLimit) {
                orderAmt = true;
                current = index;
                return true;
              }
              item.goodsList.some((item) => {
                if (!item.prizeType || !item.totalAmount) {
                  hasGoods = true;
                  current2 = index;
                  return true;
                }
              });
            });
            if (orderAmt) {
              return this.$message.warning(
                this.purchaseOrderConfig.orderRuleConfig.statisticType == 0
                  ? `请输入奖品${current + 1}的订单金额`
                  : `请输入奖品${current + 1}的${this.purchaseOrderUnitName}数`
              );
            }
            if (hasGoods) {
              return this.$message.warning(
                `请完善奖品${current2 + 1}的奖品信息`
              );
            }
          }
        }
      }
      if (this.ruleDTO.activityScene == 2) {
        if (
          !this.purchaseOrderConfig.orderTimeConfig.startTime ||
          !this.purchaseOrderConfig.orderTimeConfig.endTime
        ) {
          return this.$message.warning("请选择试用回购正装的下单时间");
        }
        const isTrue =
          this.purchaseOrderConfig.orderRuleConfig.sellerSkuList.some(
            (item) => item.skuIds.length == 0
          );
        if (isTrue) {
          return this.$message.warning("请选择试用商品");
        }
        if (this.purchaseOrderConfig.prizeConfig.enabled) {
          if (
            this.purchaseOrderConfig.prizeConfig.sendType == 1 &&
            !this.purchaseOrderConfig.prizeConfig.delayDays
          ) {
            return this.$message.warning("请输入确认收货时间");
          }
          if (
            this.purchaseOrderConfig.prizeConfig.sendType == 2 &&
            !this.purchaseOrderConfig.prizeConfig.delayDays2
          ) {
            return this.$message.warning("请输入活动结束发放时间");
          }
          let specifiedProduct = false;
          let hasGoods = false;
          let current = 0;
          let current2 = 0;
          this.prizeList.some((item, index) => {
            // if (item.specifiedProduct.length == 0) {
            //   specifiedProduct = true;
            //   current = index;
            //   return true;
            // }
            const obj = item.sellerSkuList.some(
              (item) => item.skuIds.length == 0
            );
            if (obj) {
              specifiedProduct = true;
              current = index;
              return true;
            }
            item.goodsList.some((item) => {
              if (!item.prizeType || !item.totalAmount) {
                hasGoods = true;
                current2 = index;
                return true;
              }
            });
          });
          if (specifiedProduct) {
            return this.$message.warning(
              `请选择试用回购正装奖品${current + 1}的指定商品`
            );
          }
          if (hasGoods) {
            return this.$message.warning(
              `请完善试用回购正装奖品${current2 + 1}的奖品信息`
            );
          }
        }
      }
      let hasStageName = false;
      let hasOrderTime = false;
      let hasSkuList = false;
      let hasDelayDays = false;
      let hasAmt = false;
      let hasGoods = false;
      this.repurchaseStages.some((item) => {
        if (!item.stageName) {
          hasStageName = true;
          return true;
        }
        if (
          item.orderTimeConfig.timeType == 1 &&
          !item.orderTimeConfig.joinDays
        ) {
          hasOrderTime = true;
          return true;
        }
        if (
          item.orderTimeConfig.timeType == 2 &&
          (!item.orderTimeConfig.startTime || !item.orderTimeConfig.endTime)
        ) {
          hasOrderTime = true;
          return true;
        }
        if (item.orderRuleConfig.filterType != 0) {
          // if (
          //   item.orderRuleConfig.filterType == 1 &&
          //   item.orderRuleConfig.skuIdList.length == 0
          // ) {
          //   hasSkuList = true;
          //   return true;
          // }
          // if (
          //   item.orderRuleConfig.filterType == 2 &&
          //   item.orderRuleConfig.skuIdList.length == 0
          // ) {
          //   hasSkuList = true;
          //   return;
          // }
          const obj = item.orderRuleConfig.sellerSkuList.find(
            (item) => item.skuIds.length == 0
          );
          if (obj) {
            hasSkuList = true;
            const types = {
              1: "指定",
              2: "排除",
            };
            const shop = item.orderRuleConfig.multiShopGoods.find(
              (item) => item.venderId == obj.venderId
            );
            this.$message.warning(
              `请选择阶段${item.stageName}${shop.shopTitle}的${
                types[item.orderRuleConfig.filterType]
              }商品`
            );
          }
        }
        if (item.prizeConfig.sendType == 1 && !item.prizeConfig.delayDays) {
          hasDelayDays = true;
          return true;
        }
        if (item.prizeConfig.sendType == 2 && !item.prizeConfig.delayDays2) {
          hasDelayDays = true;
          return true;
        }
        return item.stepPrizeList.some((row) => {
          if (!row.orderAmtLimit) {
            hasAmt = item;
            return true;
          }
          if (
            row.goodsList.some((item) => !item.prizeType || !item.totalAmount)
          ) {
            hasGoods = true;
            return true;
          }
        });
      });
      if (hasStageName) {
        return this.$message.warning("请输入复购阶段名称");
      }
      if (hasOrderTime) {
        return this.$message.warning("请完善复购阶段配置的下单时间");
      }
      if (hasSkuList) {
        return;
      }
      if (hasDelayDays) {
        return this.$message.warning("请完善复购阶段配置的奖品发放形式");
      }
      if (hasAmt) {
        let unitName = null;
        if (hasAmt.orderRuleConfig.statisticType != 0) {
          unitName = this.unitList.find(
            (item) => item.id == hasAmt.orderRuleConfig.statisticType
          )
            ? this.unitList.find(
                (item) => item.id == hasAmt.orderRuleConfig.statisticType
              ).name
            : null;
        }
        return this.$message.warning(
          `请完善复购阶段配置的${unitName ? unitName + "数" : "订单金额"}`
        );
      }
      if (hasGoods) {
        return this.$message.warning("请完善复购阶段配置的奖品设置");
      }

      if (!this.templateId) {
        return this.$message.warning("请选择活动模板");
      }
      // 公活动配置校验
      if (!useValidateMoreActSet(this)) {
        return;
      }

      //新增进店设置校验
      if (this.ruleDTO.goShopSetting == 1 && !this.ruleDTO.goShopAppId) {
        this.$message.warning("请输入小程序appId");
        return;
      }
      if (this.ruleDTO.goShopSetting == 2) {
        if (!this.ruleDTO.goShopUrl) {
          this.$message.warning("请输入指定链接");
          return;
        } else if (
          !this.ruleDTO.goShopUrl.startsWith("https://") ||
          !this.ruleDTO.goShopUrl.includes("jd.com")
        ) {
          this.$message.warning(
            "输入的内容非链接或为接口无法支持的链接，请重新设置"
          );
          return;
        }
      }
      // 小程序分享标题
      if (!this.ruleDTO.shareTitle) {
        this.$message.warning("请输入小程序分享标题");
        return;
      }
      // 小程序分享简介
      if (!this.ruleDTO.shareIntroduce) {
        this.$message.warning("请输入小程序分享简介");
        return;
      }
      if (!this.ruleForm.ruleDescription) {
        this.$message.warning("请输入活动规则");
        return;
      }
      if (this.ruleForm.isExposureItem && this.itemListFor.length == 0) {
        this.$message.warning("请选择曝光商品");
        return;
      }
      if (this.placementPosition.length == 0) {
        this.$message.warning("请选择活动投放位置！");
        return;
      }
      this.joinBlackList = true;
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if (this.isDraftEdit) {
        this.$confirm("是否保存对当前草稿的修改?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      } else {
        this.$confirm("是否存为草稿?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      }
    },
    async handleDialogCloseAnoth() {
      // 专享价奖品配置
      let prizeList = [];
      if (this.firstStageConfig.enableExclusivePrice) {
        prizeList.push({
          ...this.promotionList[0],
          prizeObjectType: 0,
          taskIndex: 1,
        });
        this.firstStageConfig.exclusivePriceConfig.designatedSku =
          this.designatedSku[0];
      }
      // 会员首购奖品设置
      if (this.firstStageConfig.enableFirstPurchase) {
        if (this.purchaseOrderConfig.prizeConfig.enabled) {
          let firstPurchasePrizeList = this.prizeList.map((item, index) => {
            return {
              ...item.goodsList[0],
              orderAmtLimit: item.orderAmtLimit,
              taskIndex: index + 1,
            };
          });
          firstPurchasePrizeList.forEach((item) => {
            prizeList.push({
              ...item,
              prizeObjectType: 1,
            });
          });
        }
      }
      // 试用正装奖品配置
      if (
        this.ruleDTO.activityScene == 2 &&
        this.purchaseOrderConfig.prizeConfig.enabled
      ) {
        let tryPrizeList = this.prizeList.map((item, index) => {
          return {
            skuIds: item.specifiedProduct.map((row) => row.skuId).join(","),
            ...item.goodsList[0],
            taskIndex: index + 1,
            venderIds: item.venderIds,
            sellerSkuList: item.sellerSkuList,
          };
        });
        tryPrizeList.forEach((item) => {
          prizeList.push({
            ...item,
            prizeObjectType: 2,
          });
        });
      }
      // 复购阶段奖品配置
      this.repurchaseStages.forEach((item, index) => {
        let repurchasePrizeList = item.stepPrizeList.map((row, it) => {
          return {
            ...row.goodsList[0],
            orderAmtLimit: row.orderAmtLimit,
            prizeObjectType: 3,
            awardLevel: index + 1,
            taskIndex: it + 1,
          };
        });
        repurchasePrizeList.forEach((prize) => {
          prizeList.push({
            ...prize,
          });
        });
      });

      if (this.purchaseOrderConfig.prizeConfig.sendType == 2) {
        this.purchaseOrderConfig.prizeConfig.delayDays =
          this.purchaseOrderConfig.prizeConfig.delayDays2;
      }
      delete this.purchaseOrderConfig.prizeConfig.delayDays2;
      if (this.ruleDTO.activityScene == 2 && this.trialProduct.length > 0) {
        this.purchaseOrderConfig.orderRuleConfig.filterType = 1;
        this.purchaseOrderConfig.orderTimeConfig.timeType = 2;
        this.purchaseOrderConfig.orderRuleConfig.skuIdList = []
          // this.trialProduct.map((item) => item.skuId);
      }
      if(this.ruleDTO.activityScene == 1 && this.firstStageConfig.enableFirstPurchase){
        this.purchaseOrderConfig.orderRuleConfig.skuIdList = []
      }
      this.firstStageConfig.purchaseOrderConfig = this.purchaseOrderConfig;

      let repurchaseStagesLsit = this.repurchaseStages.map((item, index) => {
        if (
          item.orderRuleConfig.skuIdList.length > 0 &&
          item.orderRuleConfig.skuIdList.every(
            (item) => typeof item == "string"
          )
        ) {
          item.orderRuleConfig.skuIdList = item.orderRuleConfig.skuIdList.map(
            (item) => item
          );
        } else if (item.orderRuleConfig.skuIdList.length > 0) {
          item.orderRuleConfig.skuIdList = item.orderRuleConfig.statisticType != 0 ?
          item.orderRuleConfig.skuIdList.map(
            (item) => item.skuId
          ) : []
        }

        if (item.orderRuleConfig.statisticType == 0) {
          item.orderRuleConfig.measureUnitId = "";
        } else {
          item.orderRuleConfig.measureUnitId =
            item.orderRuleConfig.statisticType;
          item.orderRuleConfig.statisticType = 1;
        }
        let stageObj = {
          stageIndex: index + 1,
          stageName: item.stageName,
          orderTimeConfig: item.orderTimeConfig,
          orderRuleConfig: item.orderRuleConfig,
          prizeConfig: {
            ...item.prizeConfig,
            delayDays:
              (item.prizeConfig.sendType == 2 && item.prizeConfig.delayDays2) ||
              item.prizeConfig.delayDays,
          },
        };
        delete stageObj.prizeConfig.delayDays2;
        return stageObj;
      });
      let ruleDTO = {
        ...this.ruleDTO,
        firstStageConfig: this.firstStageConfig,
        repurchaseStages: JSON.parse(JSON.stringify(repurchaseStagesLsit)),
        openCardFollow: this.ruleForm.openCardFollow,
        firstOpenCardTimeType: this.ruleForm.firstOpenCardTimeType,
        openCardBeforeDay: this.ruleForm.openCardBeforeDay,
        isForceRemind: this.isForceRemind,
        joinEndTime: this.ruleForm.joinEndTime,
        joinStartTime: this.ruleForm.joinStartTime,
        joinType: this.ruleForm.joinType,
        multiShopSkuType: this.multiShopSkuType,
        skuBelongVenderId:
          this.multiShopSkuType == 0 && this.itemListFor.length > 0
            ? this.itemListFor[0].belongVenderId
            : "",
      };
      if (
        ruleDTO.firstStageConfig.purchaseOrderConfig.orderRuleConfig
          .statisticType == 0
      ) {
        ruleDTO.firstStageConfig.purchaseOrderConfig.orderRuleConfig.measureUnitId =
          "";
      } else {
        ruleDTO.firstStageConfig.purchaseOrderConfig.orderRuleConfig.measureUnitId =
          ruleDTO.firstStageConfig.purchaseOrderConfig.orderRuleConfig.statisticType;
        ruleDTO.firstStageConfig.purchaseOrderConfig.orderRuleConfig.statisticType = 1;
      }
      ruleDTO.firstStageConfig.purchaseOrderConfig.orderRuleConfig.sellerSkuList =
        this.purchaseOrderConfig.orderRuleConfig.sellerSkuList.map((item) => {
          return {
            skuIds: item.skuIds,
            venderId: item.venderId,
          };
        });
      ruleDTO.repurchaseStages.forEach((item) => {
        item.orderRuleConfig.sellerSkuList =
          item.orderRuleConfig.sellerSkuList.map((row) => {
            return {
              skuIds: row.skuIds,
              venderId: row.venderId,
            };
          });
        delete item.orderRuleConfig.multiShopGoods;
      });
      let obj = {
        ...this.ruleForm,
        subType: 68,
        ruleDTO,
        pointActivityPrizeDTOList: [],
        isKeyActivity: this.isKeyActivity,
        placementPosition: this.placementPosition.join(","),
      };
      obj.pointActivityPrizeDTOList = prizeList.filter(
        (item) => item.prizeType > 0
      ).map((item) => {
        // 提交地址限制：数组转逗号分隔字符串
        if (item.prizeType == 3 && Array.isArray(item.commitAddressLimit)) {
          item.commitAddressLimit = item.commitAddressLimit.join(',');
        }
        return item;
      });

      obj.condFollow = Number(this.ruleForm.condFollow);
      obj.ruleDTO.openCardStartTime =
        this.actMember == 2 ? this.ruleDTO.openCardStartTime : "";
      obj.ruleDTO.openCardEndTime =
        this.actMember == 2 ? this.ruleDTO.openCardEndTime : "";
      obj.ruleDTO.plusObject = this.ruleDTO.plusObject;
      // 其他活动页配置
      obj.ruleDTO.customerPaperwork = JSON.stringify(this.customerPaperwork);

      //曝光商品集合设置
      obj.priceType = 0;
      obj.isExposureItem = this.ruleForm.isExposureItem ? 1 : 0;
      obj.itemList = this.itemListFor;

      // 模板
      obj.templateJson = this.templateJson;
      obj.templateId = this.templateId;

      // 活动对象处理
      // 参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
      obj.allowLevel =
        this.ruleForm.partner && this.ruleForm.partner.length
          ? this.ruleForm.partner.join(",")
          : "";

      if (this.actMember == 1) {
        obj.allowLevel = "-1";
      } else if (this.actMember == 3) {
        obj.allowLevel = "99";
        obj.crowdIds = this.peopleSelected.join(",");
      } else if (this.actMember == 2) {
        obj.allowLevel =
          this.ruleForm.partner && this.ruleForm.partner.length
            ? this.ruleForm.partner.join(",")
            : "";
        if (obj.allowLevel == "-1") {
          //会员等级设置
          let list = ["-1", "0"];
          this.levelList.forEach((item, index) => {
            let num = index + 1;
            list.push(num);
          });
          obj.allowLevel = list.join(",");
        }
      }
      obj.ruleDTO.orderCompleteLimitCount =
        this.ruleForm.orderCompleteLimitCount;
      obj.ruleDTO.orderCompleteMaxCount = this.ruleForm.orderCompleteMaxCount;
      obj.ruleDTO.orderCompleteLimitPayment =
        this.ruleForm.orderCompleteLimitPayment;
      obj.ruleDTO.orderCompleteMaxPayment =
        this.ruleForm.orderCompleteMaxPayment;
      obj.ruleDTO.lastOrderCompleteTimeType =
        this.ruleForm.lastOrderCompleteTimeType;
      if (obj.ruleDTO.lastOrderCompleteTimeType == 1) {
        obj.ruleDTO.lastOrderCompleteStartDay =
          this.ruleForm.lastOrderCompleteStartDay;
        obj.ruleDTO.lastOrderCompleteEndDay =
          this.ruleForm.lastOrderCompleteEndDay;
      } else if (obj.ruleDTO.lastOrderCompleteTimeType == 2) {
        obj.ruleDTO.lastOrderCompleteStartTime =
          this.ruleForm.lastOrderCompleteStartTime;
        obj.ruleDTO.lastOrderCompleteEndTime =
          this.ruleForm.lastOrderCompleteEndTime;
      }
      delete obj.partner;
      delete obj.openCardFollow;
      delete obj.firstOpenCardTimeType;
      delete obj.openCardBeforeDay;
      delete obj.orderCompleteLimitCount;
      delete obj.orderCompleteMaxCount;
      delete obj.orderCompleteLimitPayment;
      delete obj.orderCompleteMaxPayment;
      delete obj.lastOrderCompleteTimeType;
      delete obj.lastOrderCompleteStartDay;
      delete obj.lastOrderCompleteEndDay;
      delete obj.lastOrderCompleteStartTime;
      delete obj.lastOrderCompleteEndTime;
      if (this.checked == true || this.isDraft) {
        this.saveLoading = true;
        if (this.activityData.isStart) {
          let params = {
            activityId: this.valueRow.id,
            ruleDescription: obj.ruleDescription,
            prizes: prizeList.map((item) => {
              return {
                ...item,
                prizeId: item.id,
                title: item.title,
              };
            }),
            isExposureItem: this.ruleForm.isExposureItem ? 1 : 0, //曝光商品
            itemList: this.ruleForm.isExposureItem ? this.itemListFor : [],
            activityName: obj.activityName,
            condFollow: obj.condFollow ? 1 : 0,
            ruleDto: obj.ruleDTO,
            templateId: this.templateId,
            endTime: this.ruleForm.endTime,
            isValidBlackList: this.ruleForm.isValidBlackList,
          };
          updateCommon(params)
            .then((res) => {
              this.saveLoading = false;
              if (res && res.code == 1) {
                this.joinBlackList = false;
                this.$router.push({
                  name: "throw",
                  query: {
                    id: res.data.id,
                    activityType: res.data.activityType,
                  },
                });
                this.$message.success("修改成功");
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {
              console.error(res);
              this.saveLoading = false;
            });
        } else {
          if (this.isDraft) {
            obj.status = 5;
            delete obj.templateJson;
          } else {
            // 保存正式活动不需要status
            if (obj.status) delete obj.status;
            if (!this.activityData.isCopy) {
              // 未开始活动修改
              if (this.valueRow && this.valueRow.id) {
                obj.pointActivityId = this.valueRow.id;
                obj.id = this.valueRow.id;
              }
            } else {
              delete obj.templateJson;
            }
          }
          // 草稿箱编辑-添加活动id
          if (this.isDraftEdit) {
            obj.id = this.valueRow.id;
            // 草稿箱不需要传 pointActivityId
            if (obj.pointActivityId) delete obj.pointActivityId;
          }
          saveActivityCommon(obj)
            .then((res) => {
              this.saveLoading = false;
              if (res && res.code == 1) {
                if (this.isDraft) {
                  this.$message.success("保存成功！");
                  this.$emit("returnBack", true);
                } else {
                  this.joinBlackList = false;
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                    },
                  });
                  this.$message.success(res.message);
                }
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {
              console.error(res);
              this.saveLoading = false;
            });
        }
      } else {
        this.saveLoading = false;
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //获取活动详情
    getDetail() {
      if (this.valueRow && this.valueRow.id) {
        this.loading = true;
        getActivityDetailCommon(this.valueRow.id)
          .then((res) => {
            const {
              activityName,
              startTime,
              endTime,
              ruleDto,
              isExposureItem,
              ruleDescription,
              allowLevel,
              crowdIds,
              condFollow,
              templateId,
              pointActivityPrizeDTOList,
              isKeyActivity,
              placementPosition,
              studentSatus,
            } = res.data;
            // 统一处理奖品地址限制回显：逗号分隔字符串转数字数组
            // pointActivityPrizeDTOList = pointActivityPrizeDTOList.map((item) => {
            //   if (item.prizeType == 3) {
            //     if (item.commitAddressLimit) {
            //       item.commitAddressLimit = typeof item.commitAddressLimit === 'string'
            //         ? item.commitAddressLimit.split(',').map(Number)
            //         : item.commitAddressLimit;
            //     } else {
            //       item.commitAddressLimit = [0];
            //     }
            //   }
            //   return item;
            // });
            const {
              openCardFollow,
              firstOpenCardTimeType,
              openCardBeforeDay,
              isForceRemind,
              joinStartTime,
              joinEndTime,
              joinType,
              multiShopSkuType,
              skuBelongVenderId,
            } = ruleDto;
            this.ruleForm.activityName =
              activityName + (this.activityData.isCopy ? "复制" : "");
            this.multiShopSkuType = multiShopSkuType || 0;
            this.skuBelongVenderId = skuBelongVenderId || "";
            this.ruleForm.condFollow = condFollow ? true : false;
            this.ruleForm.isValidBlackList = res.data.isValidBlackList;
            // 学生身份
            this.ruleForm.studentSatus = studentSatus || "";
            // 活动对象配置
            if (allowLevel == "99") {
              this.peopleSelected = crowdIds.split(",");
              this.actMember = "3";
            } else if (allowLevel == "-1") {
              this.actMember = "1";
              this.ruleForm.partner = ["-1"];
            } else {
              this.actMember = "2";
              if (allowLevel.indexOf("-1") != -1) {
                this.ruleForm.partner = ["-1"];
              } else {
                this.ruleForm.partner = allowLevel.split(",");
              }
            }
            this.ruleForm.openCardFollow = openCardFollow;
            this.ruleForm.firstOpenCardTimeType = firstOpenCardTimeType;
            this.ruleForm.openCardBeforeDay = openCardBeforeDay;
            this.ruleDTO = ruleDto;
            this.isForceRemind = isForceRemind;
            this.isKeyActivity = isKeyActivity || 0;
            this.placementPosition = placementPosition
              ? placementPosition.split(",")
              : ["SHOP"];
            this.ruleForm.orderCompleteLimitCount =
              ruleDto.orderCompleteLimitCount;
            this.ruleForm.orderCompleteMaxCount = ruleDto.orderCompleteMaxCount;
            this.ruleForm.orderCompleteLimitPayment =
              ruleDto.orderCompleteLimitPayment;
            this.ruleForm.orderCompleteMaxPayment =
              ruleDto.orderCompleteMaxPayment;
            this.ruleForm.lastOrderCompleteTimeType =
              ruleDto.lastOrderCompleteTimeType || 0;
            this.ruleForm.lastOrderCompleteStartDay =
              ruleDto.lastOrderCompleteStartDay;
            this.ruleForm.lastOrderCompleteEndDay =
              ruleDto.lastOrderCompleteEndDay;
            this.ruleForm.lastOrderCompleteStartTime =
              ruleDto.lastOrderCompleteStartTime;
            this.ruleForm.lastOrderCompleteEndTime =
              ruleDto.lastOrderCompleteEndTime;

            if (ruleDto.customerPaperwork) {
              this.customerPaperwork = JSON.parse(ruleDto.customerPaperwork);
            }
            this.ruleForm.joinType = joinType; // 参与方式
            if (this.ruleForm.joinType == 0) {
              this.ruleForm.joinStartTime = joinStartTime;
              this.ruleForm.joinEndTime = joinEndTime;
              if (joinStartTime && joinEndTime) {
                this.isSignLimitTime = true;
              }
            }
            this.templateId = templateId;
            this.getPolite();

            // 场景显示
            this.firstStageConfig = ruleDto.firstStageConfig;
            // 专享价指定商品回显
            if (this.firstStageConfig.enableExclusivePrice) {
              this.designatedSku = [
                ruleDto.firstStageConfig.exclusivePriceConfig.designatedSku,
              ];
              this.designatedSkuCopy = [
                ruleDto.firstStageConfig.exclusivePriceConfig.designatedSku,
              ];
              // 专享价奖品回显
              this.promotionList = pointActivityPrizeDTOList.filter(
                (item) => item.prizeObjectType == 0
              );
            }

            // 会员首购奖品回显
            if (
              this.firstStageConfig.enableFirstPurchase &&
              this.firstStageConfig.purchaseOrderConfig.prizeConfig.enabled
            ) {
              this.prizeList = pointActivityPrizeDTOList
                .filter((item) => item.prizeObjectType == 1)
                .map((item) => {
                  if (item.prizeType == 3) {
                    if (item.commitAddressLimit) {
                      item.commitAddressLimit = typeof item.commitAddressLimit === 'string'
                        ? item.commitAddressLimit.split(',').map(Number)
                        : item.commitAddressLimit;
                    } else {
                      item.commitAddressLimit = [0];
                    }
                  }
              // return item;
                  return {
                    ...item,
                    specifiedProduct: [],
                    goodsList: [item],
                  };
                });
            }
            if (
              ruleDto.activityScene == 2 &&
              ruleDto.firstStageConfig.purchaseOrderConfig.prizeConfig.enabled
            ) {
              let prizeList = pointActivityPrizeDTOList
                .filter((item) => item.prizeObjectType == 2)
                .map((item) => {
                  if (item.prizeType == 3) {
                    if (item.commitAddressLimit) {
                      item.commitAddressLimit = typeof item.commitAddressLimit === 'string'
                        ? item.commitAddressLimit.split(',').map(Number)
                        : item.commitAddressLimit;
                    } else {
                      item.commitAddressLimit = [0];
                    }
                  }
                  return {
                    ...item,
                    specifiedProduct: [],
                    goodsList: [item],
                  };
                });
              prizeList.forEach((item, index) => {
                this.$set(
                  item,
                  "sellerSkuList",
                  item.sellerSkuList && item.sellerSkuList.length > 0
                    ? item.sellerSkuList
                    : [
                        {
                          skuIds: item.skuIds.length>0 ? item.skuIds.split(",") : [],
                          venderId: this.venderId,
                          itemList: [],
                        },
                      ]
                );
                this.$set(
                  item,
                  "venderIds",
                  item.venderIds && item.venderIds.length > 0
                    ? item.venderIds
                    : [this.venderId]
                );
                if (this.activityData.isCopy||this.isDraftEdit) {
                  // 跨店复制
                  if(item.venderIds.length>0) {
                    let index = item.venderIds.findIndex((item)=>{
                      return item == this.venderId
                    })
                    if(index==-1) {
                      item.venderIds.unshift(Number(this.venderId))
                      item.sellerSkuList.unshift({
                        venderId: Number(this.venderId),
                        skuIds: [],
                        itemList: [],
                      })
                    }
                  }
                }
                item.sellerSkuList.forEach((item) => {
                  if (item.skuIds.length > 0) {
                    getTaobaoItemListSku({
                      current: 1,
                      size: item.skuIds.length,
                      skuIds: item.skuIds,
                      venderId: item.venderId,
                    }).then((res) => {
                      this.$set(
                        item,
                        "itemList",
                        res.data.records.length > 0
                          ? res.data.records.map((item) => {
                              return {
                                skuId: item.skuId + "",
                                logo: item.logo,
                                skuName: item.skuName,
                                price: item.jdPrice,
                              };
                            })
                          : []
                        )
                    });
                  }
                });
                this.$set(
                  item,
                  "multiShopGoods",
                  item.venderIds.length > 0
                    ? useValidateMultiShopGoods(this, item.venderIds)
                    : useValidateMultiShopGoods(this, [this.venderId])
                );
              });
              this.prizeList = prizeList;
            }

            this.purchaseOrderConfig =
              ruleDto.firstStageConfig.purchaseOrderConfig;
              this.purchaseOrderConfig.orderRuleConfig.mergeOrder = this.purchaseOrderConfig.orderRuleConfig.mergeOrder || false;
            // 兼容订单获取条件字段：默认0-下单时间需在入会时间之后，1-入会和下单时间均在指定下单时间内即可满足
            if (this.purchaseOrderConfig && this.purchaseOrderConfig.orderTimeConfig) {
              // 历史数据无orderGetCondition字段，默认选中「下单时间需在入会时间后」
              if (this.purchaseOrderConfig.orderTimeConfig.orderGetCondition == null || this.purchaseOrderConfig.orderTimeConfig.orderGetCondition === undefined) {
                this.$set(this.purchaseOrderConfig.orderTimeConfig, 'orderGetCondition', 0);
              }
            }
            if (this.purchaseOrderConfig.orderRuleConfig.orderPaymentType===null) {
              this.$set(
                this.purchaseOrderConfig.orderRuleConfig,
                "orderPaymentType",
                1
              );
            }
            if (!this.purchaseOrderConfig.orderRuleConfig.statisticType) {
              this.$set(
                this.purchaseOrderConfig.orderRuleConfig,
                "statisticType",
                0
              );
            } else {
              this.$set(
                this.purchaseOrderConfig.orderRuleConfig,
                "statisticType",
                this.purchaseOrderConfig.orderRuleConfig.measureUnitId
              );
            }
            if (!this.purchaseOrderConfig.orderTimeConfig.joinDays) {
              this.$set(
                this.purchaseOrderConfig.orderTimeConfig,
                "joinDays",
                ""
              );
            }
            if (!this.purchaseOrderConfig.orderTimeConfig.startTime) {
              this.$set(
                this.purchaseOrderConfig.orderTimeConfig,
                "startTime",
                ""
              );
            }
            if (!this.purchaseOrderConfig.orderTimeConfig.endTime) {
              this.$set(
                this.purchaseOrderConfig.orderTimeConfig,
                "endTime",
                ""
              );
            }
            if (this.purchaseOrderConfig.prizeConfig.sendType == 2) {
              this.$set(
                this.purchaseOrderConfig.prizeConfig,
                "delayDays2",
                this.purchaseOrderConfig.prizeConfig.delayDays
              );
              this.purchaseOrderConfig.prizeConfig.delayDays = null;
            } else if (this.purchaseOrderConfig.prizeConfig.sendType == 1) {
              this.purchaseOrderConfig.prizeConfig.delayDays =
                this.purchaseOrderConfig.prizeConfig.delayDays;
              this.$set(
                this.purchaseOrderConfig.prizeConfig,
                "delayDays2",
                null
              );
            } else {
              this.$set(
                this.purchaseOrderConfig.prizeConfig,
                "delayDays",
                null
              );
              this.$set(
                this.purchaseOrderConfig.prizeConfig,
                "delayDays2",
                null
              );
            }
            // if (this.purchaseOrderConfig.orderRuleConfig.filterType != 0) {
              this.$set(
                this.purchaseOrderConfig.orderRuleConfig,
                "sellerSkuList",
                this.purchaseOrderConfig.orderRuleConfig.sellerSkuList &&
                  this.purchaseOrderConfig.orderRuleConfig.sellerSkuList
                    .length > 0
                  ? this.purchaseOrderConfig.orderRuleConfig.sellerSkuList
                  : [
                      {
                        skuIds:
                          this.purchaseOrderConfig.orderRuleConfig.skuIdList,
                        venderId: this.venderId,
                        itemList: [],
                      },
                    ]
              );
              this.$set(
                this.purchaseOrderConfig.orderRuleConfig,
                "venderIds",
                this.purchaseOrderConfig.orderRuleConfig.venderIds &&
                  this.purchaseOrderConfig.orderRuleConfig.venderIds.length > 0
                  ? this.purchaseOrderConfig.orderRuleConfig.venderIds
                  : [this.venderId]
              );
              if (this.activityData.isCopy||this.isDraftEdit) {
                // 跨店复制
                if(this.purchaseOrderConfig.orderRuleConfig.venderIds.length>0) {
                  let index = this.purchaseOrderConfig.orderRuleConfig.venderIds.findIndex((item)=>{
                    return item == this.venderId
                  })
                  if(index==-1) {
                    this.purchaseOrderConfig.orderRuleConfig.venderIds.unshift(Number(this.venderId))
                    this.purchaseOrderConfig.orderRuleConfig.sellerSkuList.unshift({
                      venderId: Number(this.venderId),
                      skuIds: [],
                      itemList: [],
                    })
                  }
                }
              }
              this.purchaseOrderConfig.orderRuleConfig.sellerSkuList.forEach(
                (item) => {
                  if (item.skuIds.length > 0) {
                    getTaobaoItemListSku({
                      current: 1,
                      size: item.skuIds.length,
                      skuIds: item.skuIds,
                      venderId: item.venderId,
                    }).then((res) => {
                      this.$set(
                        item,
                        "itemList",
                        res.data.records.length > 0
                          ? res.data.records.map((item) => {
                              return {
                                skuId: item.skuId + "",
                                logo: item.logo,
                                skuName: item.skuName,
                                price: item.jdPrice,
                              };
                            })
                          : []
                          )
                    });
                  }
                }
              );
            // }
            this.orderMultiShopGoods =
              this.purchaseOrderConfig.orderRuleConfig.venderIds &&
              this.purchaseOrderConfig.orderRuleConfig.venderIds.length > 0
                ? useValidateMultiShopGoods(
                    this,
                    this.purchaseOrderConfig.orderRuleConfig.venderIds
                  )
                : useValidateMultiShopGoods(this, [this.venderId]);
            this.trialMultiShopGoods =
              this.purchaseOrderConfig.orderRuleConfig.venderIds &&
              this.purchaseOrderConfig.orderRuleConfig.venderIds.length > 0
                ? useValidateMultiShopGoods(
                    this,
                    this.purchaseOrderConfig.orderRuleConfig.venderIds
                  )
                : useValidateMultiShopGoods(this, [this.venderId]);
            // 复购配置奖品回显
            this.repurchaseStages = ruleDto.repurchaseStages.map((item) => {
              if (item.prizeConfig.sendType == 2) {
                this.$set(
                  item.prizeConfig,
                  "delayDays2",
                  item.prizeConfig.delayDays
                );
                item.prizeConfig.delayDays = "";
              } else if (item.prizeConfig.sendType == 1) {
                item.prizeConfig.delayDays = item.prizeConfig.delayDays;
                this.$set(item.prizeConfig, "delayDays2", null);
              } else {
                this.$set(item.prizeConfig, "delayDays", null);
                this.$set(item.prizeConfig, "delayDays2", null);
              }
              if (
                item.orderRuleConfig.statisticType == null ||
                item.orderRuleConfig.statisticType == undefined
              ) {
                item.orderRuleConfig.statisticType = 0;
              } else if (item.orderRuleConfig.statisticType != 0) {
                item.orderRuleConfig.statisticType =
                  item.orderRuleConfig.measureUnitId;
              }
              item.orderRuleConfig.mergeOrder = item.orderRuleConfig.mergeOrder || false;
              return {
                ...item,
                stepPrizeList: [],
              };
            });
            this.repurchaseStages.forEach((item) => {
              let arr = pointActivityPrizeDTOList.filter((prize) => {
                return (
                  prize.prizeObjectType == 3 &&
                  prize.awardLevel == item.stageIndex
                );
              });
              item.stepPrizeList = arr.map((row) => {
                if (row.prizeType == 3) {
                  if (row.commitAddressLimit) {
                    row.commitAddressLimit = typeof row.commitAddressLimit === 'string'
                      ? row.commitAddressLimit.split(',').map(Number)
                      : row.commitAddressLimit;
                  } else {
                    row.commitAddressLimit = [0];
                  }
                }
                return {
                  orderAmtLimit: row.orderAmtLimit,
                  goodsList: [row],
                };
              });
              this.$set(
                item.orderRuleConfig,
                "sellerSkuList",
                item.orderRuleConfig.sellerSkuList && item.orderRuleConfig.sellerSkuList.length > 0
                  ? item.orderRuleConfig.sellerSkuList
                  : [
                      {
                        skuIds: item.orderRuleConfig.skuIdList,
                        venderId: this.venderId,
                        itemList: [],
                      },
                    ]
              );
              if (this.activityData.isCopy||this.isDraftEdit) {
                // 跨店复制
                if(item.orderRuleConfig.venderIds.length>0) {
                  let index = item.orderRuleConfig.venderIds.findIndex((item)=>{
                    return item == this.venderId
                  })
                  if(index==-1) {
                    item.orderRuleConfig.venderIds.unshift(Number(this.venderId))
                    item.orderRuleConfig.sellerSkuList.unshift({
                      venderId: Number(this.venderId),
                      skuIds: [],
                      itemList: [],
                    })
                  }
                }
              }
              item.orderRuleConfig.sellerSkuList.forEach((item) => {
                if (item.skuIds.length > 0) {
                  getTaobaoItemListSku({
                    current: 1,
                    size: item.skuIds.length,
                    skuIds: item.skuIds,
                    venderId: item.venderId,
                  }).then((res) => {
                    item.itemList =
                      res.data.records.length > 0
                        ? res.data.records.map((item) => {
                            return {
                              skuId: item.skuId + "",
                              logo: item.logo,
                              skuName: item.skuName,
                              price: item.jdPrice,
                            };
                          })
                        : [];
                  });
                }
              });
              this.$set(
                item.orderRuleConfig,
                "venderIds",
                item.orderRuleConfig.venderIds &&
                  item.orderRuleConfig.venderIds.length > 0
                  ? item.orderRuleConfig.venderIds
                  : [this.venderId]
              );
              this.$set(
                item.orderRuleConfig,
                "multiShopGoods",
                item.orderRuleConfig.venderIds.length > 0
                  ? useValidateMultiShopGoods(
                      this,
                      item.orderRuleConfig.venderIds
                    )
                  : useValidateMultiShopGoods(this, [this.venderId])
              );
            });
            this.expoMultiShopGoods =
              this.repurchaseStages[0].orderRuleConfig.multiShopGoods;
            this.loading = false;
            // v2.5 => 复制不需要回显奖品和规则
            if (!this.activityData.isCopy) {
              this.ruleForm.startTime = startTime;
              this.ruleForm.endTime = endTime;
              this.activityStartTime = startTime;
              this.activityEndTime = endTime;

              this.ruleForm.ruleDescription = ruleDescription;
            }
            this.ruleForm.isExposureItem = isExposureItem ? true : false;
            this.itemListFor = res.data.itemList;
            this.templateJson = JSON.parse(res.data.templateJson);
            if (this.activityData.isCopy) {
              // 专享价配置
              this.promotionList = [
                {
                  assetsId: null, // 资产项id(计划id优惠卷id商品id)
                  prizeType: null,
                  price: null,
                  logo: null,
                  title: "",
                  totalAmount: null,
                },
              ];
              this.designatedSku = [];
              // 复购阶段配置
              this.repurchaseStages.forEach((item) => {
                item.stepPrizeList.forEach((row) => {
                  row.orderAmtLimit = "";
                  row.goodsList = [
                    {
                      assetsId: "",
                      title: "",
                      logo: "",
                      prize: "",
                      prizeType: null,
                      totalAmount: null,
                    },
                  ];
                });
              });
              this.prizeList.forEach((item) => {
                item.orderAmtLimit = null;
                item.specifiedProduct = [];
                item.goodsList = [
                  {
                    assetsId: "",
                    title: "",
                    logo: "",
                    prize: "",
                    prizeType: null,
                    totalAmount: null,
                  },
                ];
              });
              this.ruleForm.ruleDescription = "";
            }
          })
          .catch((res) => {
            console.error(res);
          });
      } else {
        this.activityStartTime = this.$getDate(30)[0];
        this.activityEndTime = this.$getDate(30)[1];
        this.hdTaskTemplateGroup();
      }
    },
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if (!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      this.localStepNum = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 28px 28px 1px 24px;
    margin-bottom: 29px;
  }

  .logo-style {
    margin-top: 8px;
    width: 90px;
    height: 90px;
  }
  .setting-box {
    background: #fafafa;
    padding: 10px;
    border-radius: 4px;
  }
  .prize-logo {
    width: 56px;
    height: 56px;
    margin-top: 8px;
  }
  .ml8 {
    margin-left: 8px;
  }
  .ml12 {
    margin-left: 12px;
  }
  .ml20 {
    margin-left: 30px;
  }
  .mr8 {
    margin-right: 8px;
  }
  .mt12 {
    margin-top: 12px;
  }
  .mb12 {
    margin-bottom: 12px;
  }
  .w90 {
    width: 90px;
  }
  .w380 {
    width: 380px;
  }
  .tips_red {
    color: #ff4d4f;
  }
  .buttonGroup {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #666;
  }
  .prize_box {
    background: #fafafa;
    padding: 16px;
    border-radius: 4px;
    &_middle {
      padding-top: 10px;
    }
    &_step {
      margin-top: 16px;
      &_top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 4px 10px;
        background-color: #f0f2f7;
        &__delete {
          cursor: pointer;
        }
      }
      &_center {
        background-color: #fff;
        padding: 10px 0px;
      }
    }
  }

  .prize-set {
    position: relative;
    background-color: #fff;
    padding: 16px;
    border-radius: 4px;
    .delete-icon {
      position: absolute;
      top: 16px;
      right: 16px;
      font-size: 18px;
      cursor: pointer;
      &:hover {
        color: #ff4d4f;
      }
    }
  }
  .specified-box {
    background-color: #e6e6e6;
    padding: 16px 16px 0;
    border-radius: 4px;
    flex-wrap: wrap;
  }
  .btn-bg {
    margin-top: 5px;
    width: 80px;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .prize-item {
    flex-shrink: 0;
    width: 80px;
    height: 80px;
    position: relative;
    margin-right: 16px;
    margin-bottom: 16px;
    .prize-img {
      width: 100%;
      height: 100%;
      border-radius: 4px;
    }
    .del-icon {
      position: absolute;
      right: -8px;
      top: -8px;
      width: 20px;
      height: 20px;

      cursor: pointer;
    }
  }
  .ui-box {
    width: fit-content;
    border-radius: 4px;
  }
}
.goToMeasureUnitText {
  color: #3159ff;
  cursor: pointer;
}
</style>
